/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /** A simple UUID parser */
  DateTime: { input: string; output: string; }
  JSON: { input: { [key: string]: any }; output: { [key: string]: any }; }
};

export enum ActionType {
  Create = 'CREATE',
  Delete = 'DELETE',
  DeleteAll = 'DELETE_ALL',
  SoftDelete = 'SOFT_DELETE',
  Update = 'UPDATE'
}

export type AdminCreateItemRequestInput = {
  guestId?: InputMaybe<Scalars['ID']['input']>;
  guestMessage?: InputMaybe<Scalars['String']['input']>;
  pickedProductInput: Array<OnlineOrderPickedProductInput>;
  tableId: Scalars['ID']['input'];
};

export type AdminQuickSetupInput = {
  additionalAddress: Scalars['String']['input'];
  additionalEmail?: InputMaybe<Array<Scalars['String']['input']>>;
  addressCountry: Scalars['String']['input'];
  addressLocality: Scalars['String']['input'];
  addressRegion: Scalars['String']['input'];
  businessEmail: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  businessPhone: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Features>>;
  googleLink?: InputMaybe<Scalars['String']['input']>;
  initHubpage: Scalars['Boolean']['input'];
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  openingTimes: QuickSetupOpeningTimesInput;
  postalCode: Scalars['String']['input'];
  priceListLink?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
  subDomain: Scalars['String']['input'];
  tiktokLink?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AggregatedInvoiceReport = {
  __typename?: 'AggregatedInvoiceReport';
  totalAmount: Scalars['Int']['output'];
  totalInvoices: Scalars['Int']['output'];
};

export type Allergy = {
  __typename?: 'Allergy';
  code: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
};

export type AppointmentAvailability = {
  __typename?: 'AppointmentAvailability';
  slots: Array<AppointmentTimeSlot>;
};

export type AppointmentBranchConfiguration = {
  __typename?: 'AppointmentBranchConfiguration';
  appointmentLeadMinutes: Scalars['Int']['output'];
  appointmentPause: Scalars['Boolean']['output'];
  appointmentReactiveTimestamp?: Maybe<Scalars['DateTime']['output']>;
  appointmentTraitMinutes: Scalars['Int']['output'];
  autoConfirm: Scalars['Boolean']['output'];
  branch: StoreFront_Branch;
  branchId: Scalars['ID']['output'];
  capacityEnabled: Scalars['Boolean']['output'];
  enable: Scalars['Boolean']['output'];
  hourBlocking: Scalars['Int']['output'];
  menu?: Maybe<ServiceMenu>;
  menuId?: Maybe<Scalars['ID']['output']>;
  reminderTime: Scalars['Int']['output'];
};

export type AppointmentBranchSubscribe = {
  __typename?: 'AppointmentBranchSubscribe';
  appointment: NailAppointment;
  event: SubscribeEvent;
};

export type AppointmentConfigurationUpdateInput = {
  appointmentLeadMinutes?: InputMaybe<Scalars['Int']['input']>;
  appointmentPause?: InputMaybe<Scalars['Boolean']['input']>;
  appointmentTraitMinutes?: InputMaybe<Scalars['Int']['input']>;
  autoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  capacityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  hourBlocking?: InputMaybe<Scalars['Int']['input']>;
  menuId?: InputMaybe<Scalars['ID']['input']>;
  reminderTime?: InputMaybe<Scalars['Int']['input']>;
};

export enum AppointmentConfirmationStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Waiting = 'WAITING'
}

export type AppointmentTimeSlot = {
  __typename?: 'AppointmentTimeSlot';
  spotsOpen: Scalars['Int']['output'];
  spotsTotal?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['DateTime']['output'];
};

export type AttributeChange = {
  __typename?: 'AttributeChange';
  key: Scalars['String']['output'];
  new?: Maybe<Scalars['String']['output']>;
  old?: Maybe<Scalars['String']['output']>;
};

export enum Author {
  Bot = 'BOT',
  Guest = 'GUEST',
  Owner = 'OWNER'
}

export type AvailableNewsBannerFilter = {
  platforms: BannerPlatform;
};

export type AvailableTopBannerFilter = {
  platforms: BannerPlatform;
};

export type Banner = {
  clickCount: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  platforms: Array<BannerPlatform>;
  startTime: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewCount: Scalars['Int']['output'];
};

export enum BannerPlatform {
  DigitalMenu = 'DIGITAL_MENU',
  Hubpage = 'HUBPAGE',
  NailAppointment = 'NAIL_APPOINTMENT',
  OnlineOrder = 'ONLINE_ORDER',
  TableReservation = 'TABLE_RESERVATION'
}

export enum BannerStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export enum BannerType {
  NewsBanner = 'NEWS_BANNER',
  TopBanner = 'TOP_BANNER'
}

export type BatchUpdateTableEntry = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  seats: Scalars['Int']['input'];
  tableGroupId: Scalars['ID']['input'];
};

export type Branch = {
  __typename?: 'Branch';
  addressCountry: Scalars['String']['output'];
  addressLocality: Scalars['String']['output'];
  addressRegion: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  priceListLink?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type BranchOnlineOrderHappyHour = {
  __typename?: 'BranchOnlineOrderHappyHour';
  branchId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  onlineOrderHappyHourId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CancelReason = {
  __typename?: 'CancelReason';
  appointmentId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nailAppointment?: Maybe<NailAppointment>;
  note?: Maybe<Scalars['String']['output']>;
  onlineOrder?: Maybe<OnlineOrder>;
  onlineOrderId?: Maybe<Scalars['String']['output']>;
  reason: Array<CancelReasonEnum>;
  tableReservation?: Maybe<TableReservation>;
  tableReservationId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CancelReasonEnum {
  Busy = 'BUSY',
  NoInterest = 'NO_INTEREST',
  NoReason = 'NO_REASON',
  Other = 'OTHER',
  SoftwareIssue = 'SOFTWARE_ISSUE'
}

export enum CategoryStyle {
  Style_1 = 'STYLE_1',
  Style_2 = 'STYLE_2'
}

export type CheckOverlapServiceInput = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type CheckOverlapServiceResult = {
  __typename?: 'CheckOverlapServiceResult';
  appointment: Scalars['Int']['output'];
  onlineOrder: Scalars['Int']['output'];
  reservation: Scalars['Int']['output'];
};

export type CloseOrderInput = {
  paymentMethod: LocalPaymentMethod;
};

export type Company = {
  __typename?: 'Company';
  branch?: Maybe<Array<Branch>>;
  category: Array<CompanyCategory>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<CompanyFeature>>;
  googleLink?: Maybe<Scalars['String']['output']>;
  hubPage?: Maybe<HubPage>;
  id: Scalars['ID']['output'];
  imprintCompanyName?: Maybe<Scalars['String']['output']>;
  imprintCompanyTaxId?: Maybe<Scalars['String']['output']>;
  imprintEmail?: Maybe<Scalars['String']['output']>;
  imprintOwner?: Maybe<Scalars['String']['output']>;
  imprintOwnerTaxId?: Maybe<Scalars['String']['output']>;
  imprintPhone?: Maybe<Scalars['String']['output']>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  settings: CompanySettings;
  tiktokLink?: Maybe<Scalars['String']['output']>;
};

export enum CompanyCategory {
  Restaurant = 'RESTAURANT',
  Service = 'SERVICE'
}

export type CompanyContract = {
  __typename?: 'CompanyContract';
  categoryCode: Scalars['String']['output'];
  companyContractCategory: CompanyContractCategory;
  companyContractChange?: Maybe<Array<CompanyContractChange>>;
  companyContractFee?: Maybe<Array<CompanyContractFee>>;
  companyId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  customerNote?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  hasPayed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  paymentAmount: Scalars['Int']['output'];
  paymentCurrency: Scalars['String']['output'];
  serviceTitle: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type CompanyContractCategory = {
  __typename?: 'CompanyContractCategory';
  code: Scalars['ID']['output'];
  companyContracts: Array<CompanyContract>;
  title: Scalars['String']['output'];
};

export type CompanyContractChange = {
  __typename?: 'CompanyContractChange';
  contractId: Scalars['ID']['output'];
  data: Array<AttributeChange>;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type CompanyContractCreateInput = {
  customerName: Scalars['String']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  hasPayed: Scalars['Boolean']['input'];
  paymentAmount: Scalars['Int']['input'];
  paymentCurrency: Scalars['String']['input'];
  serviceTitle: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type CompanyContractFee = {
  __typename?: 'CompanyContractFee';
  amount: Scalars['Int']['output'];
  companyContractFeeChange: Array<CompanyContractFeeChange>;
  companyContractId: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CompanyContractFeeChange = {
  __typename?: 'CompanyContractFeeChange';
  contractFeeId: Scalars['ID']['output'];
  data: Array<AttributeChange>;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type CompanyContractFeeCreateInput = {
  amount: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CompanyContractFeeUpdateInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyContractStatus = {
  __typename?: 'CompanyContractStatus';
  category: Array<CompanyCategory>;
  companyContractStatusEnum: CompanyContractStatusEnum;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum CompanyContractStatusEnum {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  ExpireSoon = 'EXPIRE_SOON',
  NotPayed = 'NOT_PAYED',
  NoContract = 'NO_CONTRACT'
}

export type CompanyContractUpdateInput = {
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  hasPayed?: InputMaybe<Scalars['Boolean']['input']>;
  paymentAmount?: InputMaybe<Scalars['Int']['input']>;
  paymentCurrency?: InputMaybe<Scalars['String']['input']>;
  serviceTitle?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyContractWithStatus = {
  __typename?: 'CompanyContractWithStatus';
  categoryCode: Scalars['String']['output'];
  companyContractCategory: CompanyContractCategory;
  companyContractChange?: Maybe<Array<CompanyContractChange>>;
  companyContractFee?: Maybe<Array<CompanyContractFee>>;
  companyId: Scalars['String']['output'];
  customerName: Scalars['String']['output'];
  customerNote?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  hasPayed: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  paymentAmount: Scalars['Int']['output'];
  paymentCurrency: Scalars['String']['output'];
  serviceTitle: Scalars['String']['output'];
  startTime: Scalars['DateTime']['output'];
  status: CompanyContractStatusEnum;
};

export type CompanyFeature = {
  __typename?: 'CompanyFeature';
  companyId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Feature;
};

export type CompanySettings = {
  __typename?: 'CompanySettings';
  currency: Scalars['String']['output'];
  customerDefaultLanguage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notificationEmails: Array<Scalars['String']['output']>;
  timezone: Scalars['String']['output'];
};

export enum ContractStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  ExpireSoon = 'EXPIRE_SOON',
  NotPayed = 'NOT_PAYED'
}

export type CopyMenuInput = {
  menuSource: MenuSource;
  title: Scalars['String']['input'];
};

export type CountReportByDate = {
  __typename?: 'CountReportByDate';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
};

export type CountReportByHour = {
  __typename?: 'CountReportByHour';
  count: Scalars['Int']['output'];
  hour: Scalars['Int']['output'];
};

export type CreateAboutUsInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  translations: Array<LocalizedAboutUsInput>;
};

export type CreateAllergyInput = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateAppointmentInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type CreateAppointmentMenuProductInput = {
  duration: Scalars['Int']['input'];
  menuProduct: CreateMenuProductInputForAppointment;
};

export type CreateBatchResult = {
  __typename?: 'CreateBatchResult';
  count: Scalars['Int']['output'];
};

export type CreateBranch = {
  addressCountry: Scalars['String']['input'];
  addressLocality: Scalars['String']['input'];
  addressRegion: Scalars['String']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  priceListLink?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
};

export type CreateCancelReasonInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  reason: Array<CancelReasonEnum>;
};

export type CreateCompanyInput = {
  category: Array<CompanyCategory>;
  currency: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateEpsonServerDirectPrintInput = {
  branchId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateFounderInput = {
  githubUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  translations: Array<LocalizedFounderInput>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateHeroBannerInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  translations: Array<LocalizedTextInput>;
};

export type CreateHolidayInput = {
  description: Scalars['String']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type CreateInternalApiKeyInput = {
  description: Scalars['String']['input'];
};

export type CreateLanguageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateLocalItemRequestInput = {
  guestId?: InputMaybe<Scalars['ID']['input']>;
  guestMessage?: InputMaybe<Scalars['String']['input']>;
  pickedProducts: Array<OnlineOrderPickedProductInput>;
};

export type CreateManyOpeningTimeData = {
  branchId: Scalars['String']['input'];
  closeTime: Scalars['String']['input'];
  daysOfWeek?: InputMaybe<Array<DaysOfWeek>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  openTime: Scalars['String']['input'];
  service: OpeningTimeServiceType;
};

export type CreateMenu = {
  allergics?: InputMaybe<Scalars['String']['input']>;
  menuSource: MenuSource;
  preferredProductPriceMode?: InputMaybe<MenuProductPriceMode>;
  title: Scalars['String']['input'];
};

export type CreateMenuProduct = {
  allergics?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  configurations: Array<MenuProductConfigurationInput>;
  description: Scalars['String']['input'];
  discountable: Scalars['Boolean']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  images: Array<Scalars['String']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  ingredients: Array<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MenuProductLabel>>;
  priceMode: MenuProductPriceMode;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateMenuProductConfigurationValue = {
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export type CreateMenuProductInputForAppointment = {
  code?: InputMaybe<Scalars['String']['input']>;
  configurations: Array<MenuProductConfigurationInput>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  sectionID?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateMenuSection = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  discountable: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateMenuSectionTimeRule = {
  daysOfWeek?: InputMaybe<Array<DaysOfWeek>>;
  end?: InputMaybe<Scalars['String']['input']>;
  isAllDays?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  type: MenuSectionTimeRuleType;
};

export type CreateNewsBannerInput = {
  allowPopup: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  endTime: Scalars['DateTime']['input'];
  imageUrl: Scalars['String']['input'];
  isActive: Scalars['Boolean']['input'];
  platforms: Array<BannerPlatform>;
  startTime: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

export type CreateOnlineOrderHappyHourInput = {
  branchIds: Array<Scalars['ID']['input']>;
  deliveryType: Array<HappyHourDeliveryType>;
  discountAmount: Scalars['Int']['input'];
  discountType: HappyHourDiscountType;
  minimumOrderAmount: Scalars['Int']['input'];
};

export type CreateOpeningTimeData = {
  branchId: Scalars['String']['input'];
  closeTime: Scalars['String']['input'];
  dayOfWeek: DaysOfWeek;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  openTime: Scalars['String']['input'];
  service: OpeningTimeServiceType;
};

export type CreatePageRuleInput = {
  allowedSections?: InputMaybe<Array<CreatePageSectionInput>>;
  name: Scalars['String']['input'];
  printerDeviceId?: InputMaybe<Scalars['String']['input']>;
  ruleId: Scalars['String']['input'];
};

export type CreatePageSectionInput = {
  menuSectionId: Scalars['String']['input'];
};

export type CreatePrintRuleInput = {
  branchId: Scalars['String']['input'];
  menuId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  printerDeviceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductConfiguration = {
  title: Scalars['String']['input'];
  type: CreateProductConfigurationType;
};

export enum CreateProductConfigurationType {
  Option = 'OPTION',
  Selection = 'SELECTION'
}

export type CreateScheduledAvailabilityLimitationInput = {
  capacity: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  service: Service;
};

export type CreateServiceContentBlockInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['ID']['input'];
  translations: Array<LocalizedServiceContentBlockInput>;
};

export type CreateServiceInput = {
  iconName: Scalars['String']['input'];
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  price: Scalars['String']['input'];
  salePrice?: InputMaybe<Scalars['String']['input']>;
  translations: Array<LocalizedServiceInput>;
};

export type CreateServiceMenuSection = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type CreateStripeApiKeyInput = {
  companyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  publishableKey: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTable = {
  name: Scalars['String']['input'];
  seats: Scalars['Int']['input'];
};

export type CreateTableGroup = {
  arrangementCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTeamInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateTemporaryAvailabilityLimitationInput = {
  capacity: Scalars['Int']['input'];
  endTime: Scalars['DateTime']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  service: Service;
  startTime: Scalars['DateTime']['input'];
};

export type CreateTestimonialInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  translations: Array<LocalizedTestimonialInput>;
};

export type CreateTopBannerInput = {
  backgroundColor: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endTime: Scalars['DateTime']['input'];
  isActive: Scalars['Boolean']['input'];
  platforms: Array<BannerPlatform>;
  startTime: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};

export type CreateUserData = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  role: Array<UserRole>;
  username: Scalars['String']['input'];
};

export type CreateUserResult = {
  __typename?: 'CreateUserResult';
  password: Scalars['String']['output'];
  user: User;
};

export type CreatedUserCompanyRole = {
  __typename?: 'CreatedUserCompanyRole';
  password: Scalars['String']['output'];
  userCompanyRole: UserCompanyRole;
};

export type Customer = {
  __typename?: 'Customer';
  customerVariants: Array<CustomerVariant>;
  emails?: Maybe<Array<CustomerEmail>>;
  id: Scalars['ID']['output'];
};

export type CustomerAppointmentHistoryResult = {
  __typename?: 'CustomerAppointmentHistoryResult';
  appointmentId: Scalars['ID']['output'];
  detail: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type CustomerEmail = {
  __typename?: 'CustomerEmail';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  receiveNewsletter: Scalars['Boolean']['output'];
};

export type CustomerSummaryMetrics = {
  __typename?: 'CustomerSummaryMetrics';
  newCustomers: Scalars['Int']['output'];
  returningCustomers: Scalars['Int']['output'];
};

export type CustomerSummaryResult = {
  __typename?: 'CustomerSummaryResult';
  newCustomers: Scalars['Int']['output'];
  returningCustomers: Scalars['Int']['output'];
};

export type CustomerVariant = {
  __typename?: 'CustomerVariant';
  additionalAddress?: Maybe<Scalars['String']['output']>;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLocality?: Maybe<Scalars['String']['output']>;
  addressRegion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['ID']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nailAppointment?: Maybe<NailAppointment>;
  name: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  postalCode?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DailyInvoiceReport = {
  __typename?: 'DailyInvoiceReport';
  count: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  total: Scalars['Float']['output'];
};

export enum DaysOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DeleteBatchResult = {
  __typename?: 'DeleteBatchResult';
  count: Scalars['Int']['output'];
};

export enum DeliveryDiscountType {
  Amount = 'AMOUNT',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export type DigitalMenuOverviewMetrics = {
  __typename?: 'DigitalMenuOverviewMetrics';
  averageOrderDuration: Scalars['Float']['output'];
  averageRevenuePerOrder: Scalars['Float']['output'];
  totalOrders: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export enum Entity {
  Allergy = 'ALLERGY',
  Analytic = 'ANALYTIC',
  Appointment = 'APPOINTMENT',
  Banner = 'BANNER',
  Branch = 'BRANCH',
  Company = 'COMPANY',
  CompanyContract = 'COMPANY_CONTRACT',
  CompanyContractFee = 'COMPANY_CONTRACT_FEE',
  EpsonPrinter = 'EPSON_PRINTER',
  EpsonServerDirectPrint = 'EPSON_SERVER_DIRECT_PRINT',
  HappyHour = 'HAPPY_HOUR',
  Holiday = 'HOLIDAY',
  HubPage = 'HUB_PAGE',
  Invoice = 'INVOICE',
  Menu = 'MENU',
  MenuPreview = 'MENU_PREVIEW',
  MenuProduct = 'MENU_PRODUCT',
  MenuProductConfiguration = 'MENU_PRODUCT_CONFIGURATION',
  MenuProductConfigurationValue = 'MENU_PRODUCT_CONFIGURATION_VALUE',
  NailAppointmentMenuProduct = 'NAIL_APPOINTMENT_MENU_PRODUCT',
  OnlineOrder = 'ONLINE_ORDER',
  OnlineOrderBranchConfiguration = 'ONLINE_ORDER_BRANCH_CONFIGURATION',
  OpeningTime = 'OPENING_TIME',
  Order = 'ORDER',
  OrderTask = 'ORDER_TASK',
  Table = 'TABLE',
  TableBatch = 'TABLE_BATCH',
  TableGroup = 'TABLE_GROUP',
  TableReservation = 'TABLE_RESERVATION',
  User = 'USER',
  UserCompanyRole = 'USER_COMPANY_ROLE'
}

export type EpsonPrinterDevice = {
  __typename?: 'EpsonPrinterDevice';
  abstatus?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  epsonServerDirectPrint: EpsonServerDirectPrint;
  epsonServerDirectPrintId: Scalars['String']['output'];
  latestPrintError?: Maybe<Scalars['String']['output']>;
  latestPrintStatus?: Maybe<Scalars['String']['output']>;
  printerDevice: PrinterDevice;
  printerDeviceId: Scalars['ID']['output'];
};

export type EpsonServerDirectPrint = {
  __typename?: 'EpsonServerDirectPrint';
  branch: Branch;
  branchId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  epsonPrinterDevice?: Maybe<Array<EpsonPrinterDevice>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export enum Feature {
  LocalOrder = 'LOCAL_ORDER',
  NailAppointment = 'NAIL_APPOINTMENT',
  NailAppointmentCapacity = 'NAIL_APPOINTMENT_CAPACITY',
  OnlineOrder = 'ONLINE_ORDER',
  OnlineOrderCapacity = 'ONLINE_ORDER_CAPACITY',
  TableReservation = 'TABLE_RESERVATION',
  TableReservationCapacity = 'TABLE_RESERVATION_CAPACITY'
}

export enum Features {
  Appointment = 'APPOINTMENT',
  OnlineOrder = 'ONLINE_ORDER',
  Reservation = 'RESERVATION'
}

export type GlobalConfiguration = {
  __typename?: 'GlobalConfiguration';
  key: Scalars['ID']['output'];
  value: Array<Scalars['String']['output']>;
};

export type GoogleCalendarIntegration = {
  __typename?: 'GoogleCalendarIntegration';
  calendarId: Scalars['String']['output'];
  calendarName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  googleIntegration: GoogleIntegration;
  googleIntegrationId: Scalars['String']['output'];
  service: GoogleCalendarSyncService;
  syncAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum GoogleCalendarSyncService {
  Appointment = 'APPOINTMENT'
}

export type GoogleIntegration = {
  __typename?: 'GoogleIntegration';
  companyId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  googleCalendarIntegrations?: Maybe<Array<GoogleCalendarIntegration>>;
  id: Scalars['String']['output'];
};

export type GridLayout = {
  __typename?: 'GridLayout';
  mesh?: Maybe<TableGridLayout>;
};

export type GridLayoutInput = {
  mesh?: InputMaybe<TableGridLayoutInput>;
};

export enum HappyHourDeliveryType {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export enum HappyHourDiscountType {
  Amount = 'AMOUNT',
  Percentage = 'PERCENTAGE'
}

export enum HappyHourMode {
  Advanced = 'ADVANCED',
  Basic = 'BASIC'
}

export type Holiday = {
  __typename?: 'Holiday';
  branchId: Scalars['ID']['output'];
  description: Scalars['String']['output'];
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type HourlyDistributionItem = {
  __typename?: 'HourlyDistributionItem';
  appointmentCount: Scalars['Int']['output'];
  hour: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type HourlyDistributionResult = {
  __typename?: 'HourlyDistributionResult';
  guestCount: Scalars['Int']['output'];
  hour: Scalars['Int']['output'];
  reservationCount: Scalars['Int']['output'];
};

export type HourlyOrderDistributionItem = {
  __typename?: 'HourlyOrderDistributionItem';
  hour: Scalars['Int']['output'];
  orderCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type HubPage = {
  __typename?: 'HubPage';
  alternateBookingUrl?: Maybe<Scalars['String']['output']>;
  alternateUrl?: Maybe<Scalars['String']['output']>;
  alternateUrlEnable: Scalars['Boolean']['output'];
  banner?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  images: Array<Scalars['String']['output']>;
  subDomain: Scalars['String']['output'];
};

export type HubPageContent = {
  __typename?: 'HubPageContent';
  additionalAddress?: Maybe<Scalars['String']['output']>;
  addressCountry: Scalars['String']['output'];
  addressLocality: Scalars['String']['output'];
  addressRegion: Scalars['String']['output'];
  alternateBookingUrl?: Maybe<Scalars['String']['output']>;
  alternateUrl?: Maybe<Scalars['String']['output']>;
  alternateUrlEnable: Scalars['Boolean']['output'];
  appointmentEnabled?: Maybe<Scalars['Boolean']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  branchID: Scalars['ID']['output'];
  companyID: Scalars['ID']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  deliveryEnable?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  facebookLink?: Maybe<Scalars['String']['output']>;
  googleLink?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  imprintCompanyName?: Maybe<Scalars['String']['output']>;
  imprintCompanyTaxId?: Maybe<Scalars['String']['output']>;
  imprintEmail?: Maybe<Scalars['String']['output']>;
  imprintOwner?: Maybe<Scalars['String']['output']>;
  imprintOwnerTaxId?: Maybe<Scalars['String']['output']>;
  imprintPhone?: Maybe<Scalars['String']['output']>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Use `pickupEnable` or `deliveryEnable`. */
  onlineOrderEnabled?: Maybe<Scalars['Boolean']['output']>;
  openingTime: Array<OpeningTime>;
  pickupEnable?: Maybe<Scalars['Boolean']['output']>;
  postalCode: Scalars['String']['output'];
  priceListLink?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  tableReservationEnabled?: Maybe<Scalars['Boolean']['output']>;
  tiktokLink?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type HubPageUpdateInput = {
  alternateBookingUrl?: InputMaybe<Scalars['String']['input']>;
  alternateUrl?: InputMaybe<Scalars['String']['input']>;
  alternateUrlEnable?: InputMaybe<Scalars['Boolean']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
};

export type InternalApiKey = {
  __typename?: 'InternalAPIKey';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  branchId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoiceLines?: Maybe<Array<InvoiceLine>>;
  invoiceSecondaryLines?: Maybe<Array<InvoiceSecondaryLines>>;
  place?: Maybe<Scalars['String']['output']>;
  shortID: Scalars['ID']['output'];
  stripeCheckoutSession?: Maybe<StripeCheckoutSession>;
  total: Scalars['Int']['output'];
};

export type InvoiceFilter = {
  branchId?: InputMaybe<Scalars['String']['input']>;
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  id: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type InvoiceReport = {
  __typename?: 'InvoiceReport';
  daily: Array<DailyInvoiceReport>;
};

export enum InvoiceSecondaryLineCategory {
  Discount = 'DISCOUNT',
  Service = 'SERVICE',
  Tax = 'TAX'
}

export type InvoiceSecondaryLines = {
  __typename?: 'InvoiceSecondaryLines';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoiceCategory: InvoiceSecondaryLineCategory;
  price: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type InvoicesFilter = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type ItemRequestWithLocalOrderData = {
  __typename?: 'ItemRequestWithLocalOrderData';
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  guestMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  localOrder: LocalOrder;
  printStatus: LocalOrderItemRequestPrintStatus;
  products: Array<LocalOrderItemRequestProduct>;
};

export type LandingPageAboutUs = {
  __typename?: 'LandingPageAboutUs';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  translations: Array<LandingPageAboutUsTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LandingPageAboutUsTranslation = {
  __typename?: 'LandingPageAboutUsTranslation';
  description: Scalars['String']['output'];
  langCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LandingPageFounder = {
  __typename?: 'LandingPageFounder';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  githubUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
  role: Scalars['String']['output'];
  translations: Array<LandingPageFounderTranslation>;
  twitterUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LandingPageFounderTranslation = {
  __typename?: 'LandingPageFounderTranslation';
  description: Scalars['String']['output'];
  langCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type LandingPageHeroBanner = {
  __typename?: 'LandingPageHeroBanner';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  orderIndex: Scalars['Int']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  translations: Array<LandingPageHeroBannerTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LandingPageHeroBannerTranslation = {
  __typename?: 'LandingPageHeroBannerTranslation';
  langCode: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LandingPageService = {
  __typename?: 'LandingPageService';
  contentBlocks: Array<LandingPageServiceContentBlock>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  orderIndex: Scalars['Int']['output'];
  price: Scalars['String']['output'];
  salePrice?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  translations: Array<LandingPageServiceTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LandingPageServiceContentBlock = {
  __typename?: 'LandingPageServiceContentBlock';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  orderIndex: Scalars['Int']['output'];
  serviceId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  translations: Array<LandingPageServiceContentBlockTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LandingPageServiceContentBlockTranslation = {
  __typename?: 'LandingPageServiceContentBlockTranslation';
  description: Scalars['String']['output'];
  langCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LandingPageServiceTranslation = {
  __typename?: 'LandingPageServiceTranslation';
  description: Scalars['String']['output'];
  langCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type LandingPageTestimonial = {
  __typename?: 'LandingPageTestimonial';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  company: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  translations: Array<LandingPageTestimonialTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LandingPageTestimonialTranslation = {
  __typename?: 'LandingPageTestimonialTranslation';
  company: Scalars['String']['output'];
  content: Scalars['String']['output'];
  langCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LandingPage_Language = {
  __typename?: 'LandingPage_Language';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
};

export type LocalOrder = {
  __typename?: 'LocalOrder';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  itemsRequests?: Maybe<Array<LocalOrderItemRequest>>;
  paymentMethod?: Maybe<LocalPaymentMethod>;
  serviceRequests?: Maybe<Array<LocalOrderRequest>>;
  state: LocalOrderState;
  table: LocalOrderTable;
  tableId: Scalars['String']['output'];
  userState: LocalOrderUserState;
};

export type LocalOrderBillGroup = {
  __typename?: 'LocalOrderBillGroup';
  guest?: Maybe<LocalOrderGuest>;
  itemRequests: Array<LocalOrderGuestBillItem>;
  subtotal: Scalars['Int']['output'];
};

export type LocalOrderBillSummary = {
  __typename?: 'LocalOrderBillSummary';
  grandTotal: Scalars['Int']['output'];
  groups: Array<LocalOrderBillGroup>;
};

export type LocalOrderConfiguration = {
  __typename?: 'LocalOrderConfiguration';
  branch: StoreFront_Branch;
  branchId: Scalars['ID']['output'];
  featureEnabled?: Maybe<Scalars['Boolean']['output']>;
  menu?: Maybe<Storefront_Menu>;
  menuId?: Maybe<Scalars['String']['output']>;
  printToKitchen: Scalars['Boolean']['output'];
  status: Scalars['Boolean']['output'];
};

export type LocalOrderConfigurationUpdateInput = {
  menuId?: InputMaybe<Scalars['ID']['input']>;
  printToKitchen?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocalOrderGuest = {
  __typename?: 'LocalOrderGuest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isOwner: Scalars['Boolean']['output'];
  itemRequestCount: Scalars['Int']['output'];
  localOrderId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subtotal: Scalars['Int']['output'];
};

export type LocalOrderGuestBill = {
  __typename?: 'LocalOrderGuestBill';
  guest?: Maybe<LocalOrderGuest>;
  itemRequests: Array<LocalOrderGuestBillItem>;
  subtotal: Scalars['Int']['output'];
};

export type LocalOrderGuestBillItem = {
  __typename?: 'LocalOrderGuestBillItem';
  createdAt: Scalars['DateTime']['output'];
  guestMessage?: Maybe<Scalars['String']['output']>;
  itemRequestId: Scalars['ID']['output'];
  products: Array<LocalOrderItemRequestProduct>;
  status: LocalOrderItemRequestStatus;
  subtotal: Scalars['Int']['output'];
};

export type LocalOrderHistoryFilter = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type LocalOrderItemRequest = {
  __typename?: 'LocalOrderItemRequest';
  createdAt: Scalars['DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  guest?: Maybe<LocalOrderGuest>;
  guestId?: Maybe<Scalars['ID']['output']>;
  guestMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  printStatus: LocalOrderItemRequestPrintStatus;
  products: Array<LocalOrderItemRequestProduct>;
  status: LocalOrderItemRequestStatus;
};

export enum LocalOrderItemRequestPrintStatus {
  Done = 'DONE',
  Error = 'ERROR',
  Processing = 'PROCESSING'
}

export type LocalOrderItemRequestProduct = {
  __typename?: 'LocalOrderItemRequestProduct';
  id: Scalars['ID']['output'];
  productSnapshot: MenuProductSnapshot;
  quantity: Scalars['Int']['output'];
};

export enum LocalOrderItemRequestStatus {
  Cancelled = 'CANCELLED',
  Cooking = 'COOKING',
  Done = 'DONE'
}

export type LocalOrderRequest = {
  __typename?: 'LocalOrderRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  processed: Scalars['Boolean']['output'];
  type: LocalOrderRequestType;
};

export enum LocalOrderRequestType {
  CallWaiter = 'CALL_WAITER',
  CloseOrder = 'CLOSE_ORDER'
}

export enum LocalOrderState {
  Done = 'DONE',
  Init = 'INIT',
  Servicing = 'SERVICING'
}

export type LocalOrderTable = {
  __typename?: 'LocalOrderTable';
  createdAt: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  seats: Scalars['Int']['output'];
  status: LocalOrderTableStatus;
  tableGroup?: Maybe<TableGroup>;
  tableGroupId: Scalars['ID']['output'];
  updatedAt: Scalars['Int']['output'];
};

export enum LocalOrderTableStatus {
  CallWaiter = 'CALL_WAITER',
  Normal = 'NORMAL',
  Servicing = 'SERVICING',
  WaitingToClose = 'WAITING_TO_CLOSE'
}

export enum LocalOrderUserState {
  CallWaiter = 'CALL_WAITER',
  Servicing = 'SERVICING',
  WaitingToComplete = 'WAITING_TO_COMPLETE'
}

export enum LocalPaymentMethod {
  Cash = 'CASH',
  CreditCard = 'CREDIT_CARD'
}

export type LocalizedAboutUsInput = {
  description: Scalars['String']['input'];
  lang: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type LocalizedFounderInput = {
  description: Scalars['String']['input'];
  lang: Scalars['String']['input'];
  name: Scalars['String']['input'];
  role: Scalars['String']['input'];
};

export type LocalizedServiceContentBlockInput = {
  description: Scalars['String']['input'];
  lang: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type LocalizedServiceInput = {
  description: Scalars['String']['input'];
  lang: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type LocalizedTestimonialInput = {
  company: Scalars['String']['input'];
  content: Scalars['String']['input'];
  lang: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type LocalizedTextInput = {
  lang: Scalars['String']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type LoggerFilter = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type Menu = {
  __typename?: 'Menu';
  allergics: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  menuPrintRules: Array<MenuPrintRule>;
  menuProducts: Array<MenuProduct>;
  menuSource: MenuSource;
  preferredProductPriceMode: MenuProductPriceMode;
  sections: Array<MenuSection>;
  title: Scalars['String']['output'];
};

export type MenuPreview = {
  __typename?: 'MenuPreview';
  id: Scalars['ID']['output'];
  menu?: Maybe<Menu>;
  menuId?: Maybe<Scalars['String']['output']>;
  type: WebMenuPreviewType;
  url?: Maybe<Scalars['String']['output']>;
};

export type MenuPreviewCreate = {
  menuId?: InputMaybe<Scalars['String']['input']>;
  type: WebMenuPreviewType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MenuPreviewUpdate = {
  id: Scalars['ID']['input'];
  menuId?: InputMaybe<Scalars['String']['input']>;
  type: WebMenuPreviewType;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type MenuPrintPageRule = {
  __typename?: 'MenuPrintPageRule';
  allowedSections: Array<MenuPrintPageSections>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  printerDeviceId?: Maybe<Scalars['String']['output']>;
  rule: MenuPrintRule;
  ruleId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MenuPrintPageSections = {
  __typename?: 'MenuPrintPageSections';
  createdAt: Scalars['DateTime']['output'];
  menuSection: MenuSection;
  menuSectionId: Scalars['String']['output'];
  pageRule: MenuPrintPageRule;
  pageRuleId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type MenuPrintRule = {
  __typename?: 'MenuPrintRule';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  menu: Menu;
  menuId: Scalars['String']['output'];
  menuPrintRuleAssignment?: Maybe<MenuPrintRuleAssignment>;
  name: Scalars['String']['output'];
  pages: Array<MenuPrintPageRule>;
  printerDeviceId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MenuPrintRuleAssignment = {
  __typename?: 'MenuPrintRuleAssignment';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  menu: Menu;
  menuId: Scalars['String']['output'];
  menuPrintRule: MenuPrintRule;
  menuPrintRuleId: Scalars['String']['output'];
  service: MenuPrintRuleService;
  updatedAt: Scalars['DateTime']['output'];
};

export enum MenuPrintRuleService {
  DigitalMenu = 'DIGITAL_MENU',
  OnlineOrder = 'ONLINE_ORDER'
}

export type MenuProduct = {
  __typename?: 'MenuProduct';
  allergics: Scalars['String']['output'];
  code: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  configurations: Array<MenuProductConfiguration>;
  description: Scalars['String']['output'];
  discountable: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  inStock: Scalars['Boolean']['output'];
  ingredients: Array<Scalars['String']['output']>;
  labels?: Maybe<Array<MenuProductLabel>>;
  menuId: Scalars['String']['output'];
  priceMode: MenuProductPriceMode;
  section?: Maybe<MenuSection>;
  sectionId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MenuProductConfiguration = {
  __typename?: 'MenuProductConfiguration';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  type: ProductConfigurationType;
  values: Array<MenuProductConfigurationValue>;
};

export type MenuProductConfigurationInput = {
  title: Scalars['String']['input'];
  type: ProductConfigurationType;
  values: Array<MenuProductConfigurationValueInput>;
};

export type MenuProductConfigurationUpdateInput = {
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: ProductConfigurationType;
  values: Array<MenuProductConfigurationValueUpdateInput>;
};

export type MenuProductConfigurationValue = {
  __typename?: 'MenuProductConfigurationValue';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Int']['output'];
};

export type MenuProductConfigurationValueInput = {
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export type MenuProductConfigurationValueUpdateInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export enum MenuProductLabel {
  Alcohol = 'ALCOHOL',
  ExtraHot = 'EXTRA_HOT',
  Hot = 'HOT',
  Spicy = 'SPICY',
  Vegan = 'VEGAN',
  Vegetarian = 'VEGETARIAN'
}

export enum MenuProductPriceMode {
  Matrix = 'MATRIX',
  Simple = 'SIMPLE'
}

export type MenuProductSnapshot = {
  __typename?: 'MenuProductSnapshot';
  code: Scalars['String']['output'];
  configurations: Array<ProductConfigurationSnapshot>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  menuProduct: NailAppointmentMenuProduct;
  title: Scalars['String']['output'];
};

export type MenuSection = {
  __typename?: 'MenuSection';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  discountable: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inStock: Scalars['Boolean']['output'];
  menuId: Scalars['String']['output'];
  menuProducts?: Maybe<Array<MenuProduct>>;
  name: Scalars['String']['output'];
  timeRule: MenuSectionTimeRuleUnion;
};

export type MenuSectionAlwaysTimeRule = {
  __typename?: 'MenuSectionAlwaysTimeRule';
  type: MenuSectionTimeRuleType;
};

export type MenuSectionRangeTimeRule = {
  __typename?: 'MenuSectionRangeTimeRule';
  daysOfWeek?: Maybe<Array<DaysOfWeek>>;
  end: Scalars['String']['output'];
  isAllDays?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['String']['output'];
  type: MenuSectionTimeRuleType;
};

export enum MenuSectionTimeRuleType {
  Always = 'ALWAYS',
  RangeTime = 'RANGE_TIME'
}

export type MenuSectionTimeRuleUnion = MenuSectionAlwaysTimeRule | MenuSectionRangeTimeRule;

export enum MenuSource {
  DigitalMenu = 'DIGITAL_MENU',
  NailAppointment = 'NAIL_APPOINTMENT',
  Restaurant = 'RESTAURANT'
}

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']['output']>;
  adminQuickSetup: QuickSetupResult;
  analytic__scanInvoices: StatusResult;
  assignEmployeeForAppointment: PickedNailAppointmentEmployee;
  automaticFetchBranchCoordinate: Scalars['Boolean']['output'];
  clientQuickSetup: QuickSetupResult;
  copyOpeningTimes: Scalars['Boolean']['output'];
  copyPartialMenu: Menu;
  createAllergy: Allergy;
  createAppointment: NailAppointment;
  createAppointmentMenuProduct: NailAppointmentMenuProduct;
  createAppointmentMenuProductDataTeam: NailAppointmentMenuProductDataTeam;
  createBranch: Branch;
  createCancelReasonAppointment: CancelReason;
  createCancelReasonOnlineOrder: CancelReason;
  createCompany: Company;
  createContract: CompanyContract;
  createContractFee: CompanyContractFee;
  createEpsonServerDirectPrint: EpsonServerDirectPrint;
  createHappyHour: OnlineOrderHappyHour;
  createHoliday: Holiday;
  createManyOpeningTime: OpeningTime;
  createMenu: Menu;
  createMenuPreview: MenuPreview;
  createMenuProduct: MenuProduct;
  createMenuProductConfiguration: MenuProductConfiguration;
  createMenuProductConfigurationValue: MenuProductConfigurationValue;
  createMenuSection: MenuSection;
  createNewsBanner: NewsBanner;
  createOpeningTime: OpeningTime;
  createPageRule: MenuPrintPageRule;
  createPrintRule: MenuPrintRule;
  createScheduleAvailabilityLimitation: ScheduledAvailabilityLimitation;
  createServiceMenuSection: ServiceMenuSection;
  createSimpleUsers: Array<UserCompanyRole>;
  createStripeAPIKey?: Maybe<StripeApiKey>;
  createTable: Table;
  createTableBatch: Array<Table>;
  createTableGroup: TableGroup;
  createTableReservation: TableReservation;
  createTeam: Team;
  createTemporaryAvailabilityLimitation: TemporaryAvailabilityLimitation;
  createTopBanner: TopBanner;
  createUser: CreateUserResult;
  deleteAllMenuProducts: Scalars['Int']['output'];
  deleteAllTableReservations: Scalars['Boolean']['output'];
  deleteAllergy: Allergy;
  deleteAppointmentMenuProduct: Scalars['Boolean']['output'];
  deleteAppointmentMenuProductDataTeam: NailAppointmentMenuProductDataTeam;
  deleteBranch?: Maybe<Branch>;
  deleteBusinessData?: Maybe<Scalars['Boolean']['output']>;
  deleteContract: CompanyContract;
  deleteContractFee: CompanyContractFee;
  deleteEpsonServerDirectPrint: Scalars['Boolean']['output'];
  deleteGoogleIntegration: Scalars['Boolean']['output'];
  deleteHappyHour: OnlineOrderHappyHour;
  deleteHoliday: Holiday;
  deleteInternalAPIKey: Scalars['Boolean']['output'];
  deleteMenu?: Maybe<Menu>;
  deleteMenuProduct?: Maybe<MenuProduct>;
  deleteMenuProductConfiguration: Scalars['Boolean']['output'];
  deleteMenuProductConfigurationValue?: Maybe<MenuProductConfigurationValue>;
  deleteMenuSection: Scalars['Boolean']['output'];
  deleteNewsBanner: NewsBanner;
  deleteOpeningTime: OpeningTime;
  deleteOpeningTimes: Scalars['Boolean']['output'];
  deleteScheduleAvailabilityLimitation: ScheduledAvailabilityLimitation;
  deleteServiceMenuSection: Scalars['Boolean']['output'];
  deleteStripeAPIKey?: Maybe<Scalars['Boolean']['output']>;
  deleteTable: Table;
  deleteTableBatch: DeleteBatchResult;
  deleteTableGroup: TableGroup;
  deleteTeam: Team;
  deleteTemporaryAvailabilityLimitation: TemporaryAvailabilityLimitation;
  deleteTopBanner: TopBanner;
  deleteUser: User;
  digitalMenu_addItemToTable: LocalOrderItemRequest;
  duplicateAppointmentMenuProduct: NailAppointmentMenuProduct;
  duplicateMenuProduct: MenuProduct;
  generateInternalAPIKey: Scalars['String']['output'];
  generateMultipleQRCodes: Array<QrCode>;
  getUniquePrintRule: MenuPrintRule;
  initLocalOrderConfiguration: LocalOrderConfiguration;
  initiateAppointmentBranchConfiguration: AppointmentBranchConfiguration;
  invoiceDelete: Invoice;
  landingPage_createAboutUs: LandingPageAboutUs;
  landingPage_createFounder: LandingPageFounder;
  landingPage_createHeroBanner: LandingPageHeroBanner;
  landingPage_createLanguage: LandingPage_Language;
  landingPage_createService: LandingPageService;
  landingPage_createServiceContentBlock: LandingPageServiceContentBlock;
  landingPage_createTestimonial: LandingPageTestimonial;
  landingPage_deleteAboutUs: Scalars['Boolean']['output'];
  landingPage_deleteFounder: Scalars['Boolean']['output'];
  landingPage_deleteHeroBanner: Scalars['Boolean']['output'];
  landingPage_deleteLanguage: Scalars['Boolean']['output'];
  landingPage_deleteService: Scalars['Boolean']['output'];
  landingPage_deleteServiceContentBlock: Scalars['Boolean']['output'];
  landingPage_deleteTestimonial: Scalars['Boolean']['output'];
  landingPage_reorderFounders: Scalars['Boolean']['output'];
  landingPage_reorderHeroBanners: Scalars['Boolean']['output'];
  landingPage_reorderServiceContentBlocks: Scalars['Boolean']['output'];
  landingPage_reorderServices: Scalars['Boolean']['output'];
  landingPage_updateAboutUs: LandingPageAboutUs;
  landingPage_updateFounder: LandingPageFounder;
  landingPage_updateHeroBanner: LandingPageHeroBanner;
  landingPage_updateLanguage: LandingPage_Language;
  landingPage_updateService: LandingPageService;
  landingPage_updateServiceContentBlock: LandingPageServiceContentBlock;
  landingPage_updateTestimonial: LandingPageTestimonial;
  localOrder_addGuest: LocalOrderGuest;
  localOrder_assignItemRequestToGuest: LocalOrderItemRequest;
  localOrder_bulkAssignItemRequestsToGuest: Scalars['Boolean']['output'];
  localOrder_changeItemRequestState: LocalOrderItemRequest;
  localOrder_changeTable: LocalOrder;
  localOrder_closeOrder: Scalars['Boolean']['output'];
  localOrder_destroyItemRequest: LocalOrderItemRequest;
  localOrder_moveProduct: LocalOrderItemRequest;
  localOrder_printInvoice: Scalars['Boolean']['output'];
  localOrder_removeGuest: LocalOrderGuest;
  localOrder_renameGuest: LocalOrderGuest;
  localOrder_resolveNotification: LocalOrderItemRequest;
  localOrder_resolveOrderRequest: Scalars['Boolean']['output'];
  localOrder_updateProductQuantity: OnlineOrderProduct;
  onlineOrderChangeDeliveryPrice: Scalars['Boolean']['output'];
  onlineOrderOwnerCancel: Scalars['Boolean']['output'];
  onlineOrderOwnerConfirm: Scalars['Boolean']['output'];
  onlineOrderOwnerConfirmManualTransfer: Scalars['Boolean']['output'];
  onlineOrderOwnerDecline: Scalars['Boolean']['output'];
  onlineOrderOwnerDone: Scalars['Boolean']['output'];
  onlineOrderOwnerRejectManualTransfer: Scalars['Boolean']['output'];
  onlineOrderOwnerStartCooking: Scalars['Boolean']['output'];
  /** Toggle a tag on an online order. The tag must be in the server-side allow-list. */
  onlineOrderOwnerToggleTag: Scalars['Boolean']['output'];
  onlineOrderPrintToKitchen: Scalars['Boolean']['output'];
  onlineOrder_changeHappyHourMode: OnlineOrderBranchConfiguration;
  ping: Scalars['Boolean']['output'];
  preSignImageUpload: PreSignImageUpload;
  preSignPdfUpload: PreSignPdfUpload;
  pushNotificationRegisterToken: Scalars['Boolean']['output'];
  pushNotificationRevokeToken: Scalars['Boolean']['output'];
  removePrintRuleAssignment: Scalars['Boolean']['output'];
  resetCurrentUserPassword: Scalars['String']['output'];
  resetUserPassword: Scalars['String']['output'];
  setCompanyFeature: CompanyFeature;
  setGoogleCalendarService: Scalars['Boolean']['output'];
  setNotificationDiscordHook: GlobalConfiguration;
  setPanelVersion: GlobalConfiguration;
  setPrintRuleAssignment?: Maybe<MenuPrintRuleAssignment>;
  setupOnlineOrderBranchConfiguration: OnlineOrderBranchConfiguration;
  softDeletePageRule: MenuPrintPageRule;
  softDeletePrintRule: MenuPrintRule;
  storefront_cancelAppointment: NailAppointment;
  storefront_cancelReservation: TableReservation;
  storefront_cancelTableReservation: TableReservation;
  storefront_changeProductAmount: Scalars['Boolean']['output'];
  storefront_changeUserState: Scalars['Boolean']['output'];
  storefront_createAppointment: Storefront_Appointment;
  storefront_createOnlineOrder: Storefront_OnlineOrder;
  storefront_createTableReservation: TableReservation;
  storefront_localOrder_addGuest: LocalOrderGuest;
  storefront_localOrder_callWaiter: Storefront_LocalOrder;
  storefront_localOrder_createItemRequest: LocalOrderItemRequest;
  storefront_localOrder_requireClose: Storefront_LocalOrder;
  storefront_localOrder_setPaymentMethod: Storefront_LocalOrder;
  storefront_onlineOrderSetPickedProducts: Scalars['Boolean']['output'];
  storefront_onlineOrder_review_cancel: Scalars['Boolean']['output'];
  storefront_onlineOrder_review_complete: Scalars['Boolean']['output'];
  storefront_onlineOrder_submitManualTransferProof: Scalars['Boolean']['output'];
  storefront_onlineOrder_waitingPayment_cancel: Scalars['Boolean']['output'];
  storefront_onlineOrder_waitingPayment_checkPayment: Scalars['Boolean']['output'];
  /**
   * Unauthenticated presign for a customer to upload an online-payment proof.
   * Only succeeds if the referenced order is in WAITING_FOR_MANUAL_CONFIRM with
   * paymentMethod = MANUAL_BANK_TRANSFER, so it can't be used as a generic open upload.
   */
  storefront_preSignManualTransferProofUpload: PreSignImageUpload;
  storefront_userFillsContactInfo: Scalars['Boolean']['output'];
  switchTeamForAppointment: PickedNailAppointmentTeam;
  syncGoogleCalendar: Scalars['Boolean']['output'];
  tableReservationSendRemindEmail: Scalars['Boolean']['output'];
  updateAllergy: Allergy;
  updateAppointment: NailAppointment;
  updateAppointmentBranchConfiguration: AppointmentBranchConfiguration;
  updateAppointmentConfirmationStatus: NailAppointment;
  updateAppointmentMenuProduct: NailAppointmentMenuProduct;
  updateBranch: Branch;
  updateCompany: Company;
  updateCompanySettings: CompanySettings;
  updateContract: CompanyContract;
  updateContractFee: CompanyContractFee;
  updateEpsonServerDirectPrint: EpsonServerDirectPrint;
  updateHappyHour: OnlineOrderHappyHour;
  updateHoliday: Holiday;
  updateHubPage: HubPage;
  updateLocalOrderConfiguration: LocalOrderConfiguration;
  updateMenu: Menu;
  updateMenuPreview: MenuPreview;
  updateMenuProduct: MenuProduct;
  updateMenuProductConfiguration: MenuProductConfiguration;
  updateMenuProductConfigurationValue: MenuProductConfigurationValue;
  updateMenuSection: MenuSection;
  updateNewsBanner: NewsBanner;
  updateOnlineOrderConfiguration: OnlineOrderBranchConfiguration;
  updateOpeningTime: OpeningTime;
  updatePageRule: MenuPrintPageRule;
  updatePrintRule: MenuPrintRule;
  updatePrinterDevice: PrinterDevice;
  updateScheduleAvailabilityLimitation: ScheduledAvailabilityLimitation;
  updateServiceMenuSection: ServiceMenuSection;
  updateSimpleUser?: Maybe<UserCompanyRole>;
  updateStripeAPIKey?: Maybe<StripeApiKey>;
  updateTable: Table;
  updateTableBatch: Array<Table>;
  updateTableGroup: TableGroup;
  updateTableReservation: TableReservation;
  updateTableReservationConfiguration: TableReservationSetting;
  updateTableReservationConfirmationStatus: TableReservation;
  updateTableReservationStatus: TableReservation;
  updateTableReservationTable: TableReservation;
  updateTableReservationV2: TableReservation;
  updateTeam: Team;
  updateTemporaryAvailabilityLimitation: TemporaryAvailabilityLimitation;
  updateTopBanner: TopBanner;
  updateUser: User;
  updateUserNotification: UserNotification;
  userCompanyRoleCreate: CreatedUserCompanyRole;
  userCompanyRoleDelete: UserCompanyRole;
  userCompanyRoleUpdate: UserCompanyRole;
  validateStripeAPIKey: StripeApiValidatedResult;
};


export type MutationAdminQuickSetupArgs = {
  input: AdminQuickSetupInput;
};


export type MutationAnalytic__ScanInvoicesArgs = {
  companyID: Scalars['ID']['input'];
};


export type MutationAssignEmployeeForAppointmentArgs = {
  appointmentId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAutomaticFetchBranchCoordinateArgs = {
  branchID: Scalars['ID']['input'];
};


export type MutationClientQuickSetupArgs = {
  input: QuickSetupInput;
};


export type MutationCopyOpeningTimesArgs = {
  branchID: Scalars['ID']['input'];
  sourceService: OpeningTimeServiceType;
  targetService: OpeningTimeServiceType;
};


export type MutationCopyPartialMenuArgs = {
  baseMenuId: Scalars['ID']['input'];
  data: CopyMenuInput;
  productIds: Array<Scalars['String']['input']>;
};


export type MutationCreateAllergyArgs = {
  companyId: Scalars['ID']['input'];
  input: CreateAllergyInput;
};


export type MutationCreateAppointmentArgs = {
  branchId: Scalars['ID']['input'];
  input: CreateAppointmentInput;
  pickedProductInput: Array<PickedProductInput>;
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCreateAppointmentMenuProductArgs = {
  input: CreateAppointmentMenuProductInput;
  menuID: Scalars['ID']['input'];
  teamIds: Array<Scalars['String']['input']>;
};


export type MutationCreateAppointmentMenuProductDataTeamArgs = {
  serviceProductId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationCreateBranchArgs = {
  companyId: Scalars['ID']['input'];
  input: CreateBranch;
};


export type MutationCreateCancelReasonAppointmentArgs = {
  AppointmentId: Scalars['ID']['input'];
  input: CreateCancelReasonInput;
};


export type MutationCreateCancelReasonOnlineOrderArgs = {
  OnlineOrderId: Scalars['ID']['input'];
  input: CreateCancelReasonInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateContractArgs = {
  categoryCode: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  contractData: CompanyContractCreateInput;
  contractFeeData: Array<CompanyContractFeeCreateInput>;
};


export type MutationCreateContractFeeArgs = {
  contractId: Scalars['ID']['input'];
  input: CompanyContractFeeCreateInput;
};


export type MutationCreateEpsonServerDirectPrintArgs = {
  input: CreateEpsonServerDirectPrintInput;
};


export type MutationCreateHappyHourArgs = {
  input: CreateOnlineOrderHappyHourInput;
  timeRuleInput: CreateMenuSectionTimeRule;
};


export type MutationCreateHolidayArgs = {
  branchId: Scalars['ID']['input'];
  input: CreateHolidayInput;
};


export type MutationCreateManyOpeningTimeArgs = {
  input: CreateManyOpeningTimeData;
};


export type MutationCreateMenuArgs = {
  companyId: Scalars['ID']['input'];
  input: CreateMenu;
};


export type MutationCreateMenuPreviewArgs = {
  input: MenuPreviewCreate;
};


export type MutationCreateMenuProductArgs = {
  input?: InputMaybe<CreateMenuProduct>;
  menuId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateMenuProductConfigurationArgs = {
  input: CreateProductConfiguration;
  productId: Scalars['String']['input'];
};


export type MutationCreateMenuProductConfigurationValueArgs = {
  input: CreateMenuProductConfigurationValue;
  menuProductConfigurationId: Scalars['ID']['input'];
};


export type MutationCreateMenuSectionArgs = {
  input: CreateMenuSection;
  menuId: Scalars['ID']['input'];
  timeRuleInput: CreateMenuSectionTimeRule;
};


export type MutationCreateNewsBannerArgs = {
  companyId: Scalars['ID']['input'];
  input: CreateNewsBannerInput;
};


export type MutationCreateOpeningTimeArgs = {
  input: CreateOpeningTimeData;
};


export type MutationCreatePageRuleArgs = {
  input: CreatePageRuleInput;
};


export type MutationCreatePrintRuleArgs = {
  input: CreatePrintRuleInput;
};


export type MutationCreateScheduleAvailabilityLimitationArgs = {
  branchId: Scalars['ID']['input'];
  input: CreateScheduledAvailabilityLimitationInput;
  timeRuleInput: ScheduledLimitationTimeRuleInput;
};


export type MutationCreateServiceMenuSectionArgs = {
  input: CreateServiceMenuSection;
  menuId: Scalars['ID']['input'];
  timeRuleInput: CreateMenuSectionTimeRule;
};


export type MutationCreateSimpleUsersArgs = {
  companyID: Scalars['ID']['input'];
  input: Array<SimpleUserCreate>;
};


export type MutationCreateStripeApiKeyArgs = {
  input: CreateStripeApiKeyInput;
};


export type MutationCreateTableArgs = {
  data?: InputMaybe<CreateTable>;
  tableGroup: Scalars['ID']['input'];
};


export type MutationCreateTableBatchArgs = {
  data: Array<CreateTable>;
  tableGroup: Scalars['ID']['input'];
};


export type MutationCreateTableGroupArgs = {
  branchID: Scalars['ID']['input'];
  input: CreateTableGroup;
};


export type MutationCreateTableReservationArgs = {
  branchId: Scalars['ID']['input'];
  input: TableReservationCreate;
};


export type MutationCreateTeamArgs = {
  branchId: Scalars['ID']['input'];
  input: CreateTeamInput;
  memberTeam: Array<TeamMemberCreateInput>;
};


export type MutationCreateTemporaryAvailabilityLimitationArgs = {
  branchId: Scalars['ID']['input'];
  input: CreateTemporaryAvailabilityLimitationInput;
};


export type MutationCreateTopBannerArgs = {
  companyId: Scalars['ID']['input'];
  input: CreateTopBannerInput;
};


export type MutationCreateUserArgs = {
  companyID: Scalars['ID']['input'];
  data?: InputMaybe<CreateUserData>;
};


export type MutationDeleteAllMenuProductsArgs = {
  menuId: Scalars['ID']['input'];
};


export type MutationDeleteAllTableReservationsArgs = {
  branchId: Scalars['ID']['input'];
};


export type MutationDeleteAllergyArgs = {
  code: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};


export type MutationDeleteAppointmentMenuProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteAppointmentMenuProductDataTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBranchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBusinessDataArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['String']['input'];
  services: Array<Features>;
  startTime: Scalars['String']['input'];
};


export type MutationDeleteContractArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteContractFeeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEpsonServerDirectPrintArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteGoogleIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHappyHourArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteHolidayArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteInternalApiKeyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMenuArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMenuProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMenuProductConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMenuProductConfigurationValueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMenuSectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNewsBannerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOpeningTimeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOpeningTimesArgs = {
  branchID: Scalars['ID']['input'];
  service: OpeningTimeServiceType;
};


export type MutationDeleteScheduleAvailabilityLimitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteServiceMenuSectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStripeApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTableArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTableBatchArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteTableGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamArgs = {
  ID: Scalars['ID']['input'];
};


export type MutationDeleteTemporaryAvailabilityLimitationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTopBannerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDigitalMenu_AddItemToTableArgs = {
  input: AdminCreateItemRequestInput;
};


export type MutationDuplicateAppointmentMenuProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateMenuProductArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateInternalApiKeyArgs = {
  input: CreateInternalApiKeyInput;
};


export type MutationGenerateMultipleQrCodesArgs = {
  digitalMenuHost?: InputMaybe<Scalars['String']['input']>;
  tableIds: Array<Scalars['ID']['input']>;
};


export type MutationGetUniquePrintRuleArgs = {
  branchId: Scalars['ID']['input'];
  menuId: Scalars['ID']['input'];
};


export type MutationInitLocalOrderConfigurationArgs = {
  branchId: Scalars['ID']['input'];
};


export type MutationInitiateAppointmentBranchConfigurationArgs = {
  branchId: Scalars['ID']['input'];
};


export type MutationInvoiceDeleteArgs = {
  invoiceID: Scalars['ID']['input'];
};


export type MutationLandingPage_CreateAboutUsArgs = {
  input: CreateAboutUsInput;
};


export type MutationLandingPage_CreateFounderArgs = {
  input: CreateFounderInput;
};


export type MutationLandingPage_CreateHeroBannerArgs = {
  input: CreateHeroBannerInput;
};


export type MutationLandingPage_CreateLanguageArgs = {
  input: CreateLanguageInput;
};


export type MutationLandingPage_CreateServiceArgs = {
  input: CreateServiceInput;
};


export type MutationLandingPage_CreateServiceContentBlockArgs = {
  input: CreateServiceContentBlockInput;
};


export type MutationLandingPage_CreateTestimonialArgs = {
  input: CreateTestimonialInput;
};


export type MutationLandingPage_DeleteFounderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLandingPage_DeleteHeroBannerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLandingPage_DeleteLanguageArgs = {
  code: Scalars['String']['input'];
};


export type MutationLandingPage_DeleteServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLandingPage_DeleteServiceContentBlockArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLandingPage_DeleteTestimonialArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLandingPage_ReorderFoundersArgs = {
  items: Array<OrderItemInput>;
};


export type MutationLandingPage_ReorderHeroBannersArgs = {
  items: Array<OrderItemInput>;
};


export type MutationLandingPage_ReorderServiceContentBlocksArgs = {
  items: Array<OrderItemInput>;
  serviceId: Scalars['ID']['input'];
};


export type MutationLandingPage_ReorderServicesArgs = {
  items: Array<OrderItemInput>;
};


export type MutationLandingPage_UpdateAboutUsArgs = {
  input: UpdateAboutUsInput;
};


export type MutationLandingPage_UpdateFounderArgs = {
  id: Scalars['ID']['input'];
  input: UpdateFounderInput;
};


export type MutationLandingPage_UpdateHeroBannerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHeroBannerInput;
};


export type MutationLandingPage_UpdateLanguageArgs = {
  code: Scalars['String']['input'];
  input: UpdateLanguageInput;
};


export type MutationLandingPage_UpdateServiceArgs = {
  id: Scalars['ID']['input'];
  input: UpdateServiceInput;
};


export type MutationLandingPage_UpdateServiceContentBlockArgs = {
  id: Scalars['ID']['input'];
  input: UpdateServiceContentBlockInput;
};


export type MutationLandingPage_UpdateTestimonialArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTestimonialInput;
};


export type MutationLocalOrder_AddGuestArgs = {
  localOrderId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationLocalOrder_AssignItemRequestToGuestArgs = {
  guestId?: InputMaybe<Scalars['ID']['input']>;
  itemRequestId: Scalars['ID']['input'];
};


export type MutationLocalOrder_BulkAssignItemRequestsToGuestArgs = {
  guestId: Scalars['ID']['input'];
  itemRequestIds: Array<Scalars['ID']['input']>;
};


export type MutationLocalOrder_ChangeItemRequestStateArgs = {
  itemRequestId: Scalars['ID']['input'];
  status: LocalOrderItemRequestStatus;
};


export type MutationLocalOrder_ChangeTableArgs = {
  localOrderId: Scalars['ID']['input'];
  targetTableId: Scalars['ID']['input'];
};


export type MutationLocalOrder_CloseOrderArgs = {
  id: Scalars['ID']['input'];
  paymentMethod: LocalPaymentMethod;
};


export type MutationLocalOrder_DestroyItemRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLocalOrder_MoveProductArgs = {
  productId: Scalars['ID']['input'];
  targetGuestId?: InputMaybe<Scalars['ID']['input']>;
  targetItemRequestId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLocalOrder_PrintInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLocalOrder_RemoveGuestArgs = {
  guestId: Scalars['ID']['input'];
  localOrderId: Scalars['ID']['input'];
};


export type MutationLocalOrder_RenameGuestArgs = {
  guestId: Scalars['ID']['input'];
  localOrderId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationLocalOrder_ResolveNotificationArgs = {
  itemRequestId: Scalars['ID']['input'];
};


export type MutationLocalOrder_ResolveOrderRequestArgs = {
  localOrderId: Scalars['ID']['input'];
};


export type MutationLocalOrder_UpdateProductQuantityArgs = {
  localOrderProductId: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationOnlineOrderChangeDeliveryPriceArgs = {
  deliveryPrice: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type MutationOnlineOrderOwnerCancelArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOnlineOrderOwnerConfirmArgs = {
  id: Scalars['ID']['input'];
  input: OnlineOrderOwnerConfirmInput;
};


export type MutationOnlineOrderOwnerConfirmManualTransferArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOnlineOrderOwnerDeclineArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOnlineOrderOwnerDoneArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOnlineOrderOwnerRejectManualTransferArgs = {
  id: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationOnlineOrderOwnerStartCookingArgs = {
  id: Scalars['ID']['input'];
  input: OnlineOrderOwnerStartCookingInput;
};


export type MutationOnlineOrderOwnerToggleTagArgs = {
  id: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
};


export type MutationOnlineOrderPrintToKitchenArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOnlineOrder_ChangeHappyHourModeArgs = {
  id: Scalars['ID']['input'];
  mode: HappyHourMode;
};


export type MutationPreSignImageUploadArgs = {
  filename: Scalars['String']['input'];
};


export type MutationPushNotificationRegisterTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationPushNotificationRevokeTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationRemovePrintRuleAssignmentArgs = {
  menuId: Scalars['ID']['input'];
};


export type MutationResetCurrentUserPasswordArgs = {
  input: ResetCurrentUserPasswordInput;
  userID: Scalars['ID']['input'];
};


export type MutationResetUserPasswordArgs = {
  companyID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};


export type MutationSetCompanyFeatureArgs = {
  companyId: Scalars['ID']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Feature;
};


export type MutationSetGoogleCalendarServiceArgs = {
  branchID: Scalars['ID']['input'];
  enable: Scalars['Boolean']['input'];
  integrationID: Scalars['ID']['input'];
  service: GoogleCalendarSyncService;
};


export type MutationSetNotificationDiscordHookArgs = {
  urls: Array<Scalars['String']['input']>;
};


export type MutationSetPanelVersionArgs = {
  version: Scalars['String']['input'];
};


export type MutationSetPrintRuleAssignmentArgs = {
  input: SetPrintRuleAssignmentInput;
};


export type MutationSetupOnlineOrderBranchConfigurationArgs = {
  branchID: Scalars['ID']['input'];
};


export type MutationSoftDeletePageRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSoftDeletePrintRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStorefront_CancelAppointmentArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<CreateCancelReasonInput>;
};


export type MutationStorefront_CancelReservationArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<CreateCancelReasonInput>;
};


export type MutationStorefront_CancelTableReservationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStorefront_ChangeProductAmountArgs = {
  amount: Scalars['Int']['input'];
  onlineOrderProductID: Scalars['ID']['input'];
};


export type MutationStorefront_ChangeUserStateArgs = {
  onlineOrderID: Scalars['ID']['input'];
  state: OnlineOrderUserState;
};


export type MutationStorefront_CreateAppointmentArgs = {
  branchID: Scalars['ID']['input'];
  input: Storefront_CreateAppointmentInput;
  pickedProductInput: Array<Storefront_PickedProductInput>;
};


export type MutationStorefront_CreateOnlineOrderArgs = {
  branchID: Scalars['ID']['input'];
  input: OnlineOrderCreateInput;
};


export type MutationStorefront_CreateTableReservationArgs = {
  branchId: Scalars['ID']['input'];
  input: Storefront_TableReservationCreate;
};


export type MutationStorefront_LocalOrder_AddGuestArgs = {
  localOrderId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationStorefront_LocalOrder_CallWaiterArgs = {
  localOrderId: Scalars['ID']['input'];
};


export type MutationStorefront_LocalOrder_CreateItemRequestArgs = {
  input: CreateLocalItemRequestInput;
  localOrderId: Scalars['ID']['input'];
};


export type MutationStorefront_LocalOrder_RequireCloseArgs = {
  localOrderId: Scalars['ID']['input'];
};


export type MutationStorefront_LocalOrder_SetPaymentMethodArgs = {
  localOrderId: Scalars['ID']['input'];
  paymentMethod: LocalPaymentMethod;
};


export type MutationStorefront_OnlineOrderSetPickedProductsArgs = {
  customerLanguage: Scalars['String']['input'];
  onlineOrderID: Scalars['ID']['input'];
  products: Array<OnlineOrderPickedProductInput>;
  userState?: InputMaybe<OnlineOrderUserState>;
};


export type MutationStorefront_OnlineOrder_Review_CancelArgs = {
  onlineOrderID: Scalars['ID']['input'];
};


export type MutationStorefront_OnlineOrder_Review_CompleteArgs = {
  onlineOrderID: Scalars['ID']['input'];
};


export type MutationStorefront_OnlineOrder_SubmitManualTransferProofArgs = {
  input: SubmitManualTransferProofInput;
  onlineOrderID: Scalars['ID']['input'];
};


export type MutationStorefront_OnlineOrder_WaitingPayment_CancelArgs = {
  onlineOrderID: Scalars['ID']['input'];
};


export type MutationStorefront_OnlineOrder_WaitingPayment_CheckPaymentArgs = {
  onlineOrderID: Scalars['ID']['input'];
};


export type MutationStorefront_PreSignManualTransferProofUploadArgs = {
  filename: Scalars['String']['input'];
  onlineOrderID: Scalars['ID']['input'];
};


export type MutationStorefront_UserFillsContactInfoArgs = {
  input: UserContactInfoInput;
  onlineOrderID: Scalars['ID']['input'];
};


export type MutationSwitchTeamForAppointmentArgs = {
  appointmentId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
};


export type MutationSyncGoogleCalendarArgs = {
  branchID: Scalars['ID']['input'];
  integrationID: Scalars['ID']['input'];
  service: GoogleCalendarSyncService;
};


export type MutationTableReservationSendRemindEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAllergyArgs = {
  code: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
  input?: InputMaybe<UpdateAllergyInput>;
};


export type MutationUpdateAppointmentArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateAppointmentInput>;
  pickedProductInput?: InputMaybe<Array<PickedProductInput>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateAppointmentBranchConfigurationArgs = {
  branchId: Scalars['ID']['input'];
  input: AppointmentConfigurationUpdateInput;
};


export type MutationUpdateAppointmentConfirmationStatusArgs = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<NailAppointmentConfirmationStatus>;
};


export type MutationUpdateAppointmentMenuProductArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAppointmentMenuProductInput;
};


export type MutationUpdateBranchArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateBranch>;
};


export type MutationUpdateCompanyArgs = {
  companyID: Scalars['ID']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanySettingsArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCompanySettings;
};


export type MutationUpdateContractArgs = {
  contractData: CompanyContractUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateContractFeeArgs = {
  id: Scalars['ID']['input'];
  input: CompanyContractFeeUpdateInput;
};


export type MutationUpdateEpsonServerDirectPrintArgs = {
  id: Scalars['ID']['input'];
  input: UpdateEpsonServerDirectPrintInput;
};


export type MutationUpdateHappyHourArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateOnlineOrderHappyHourInput>;
  timeRuleInput?: InputMaybe<UpdateMenuSectionTimeRule>;
};


export type MutationUpdateHolidayArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHolidayInput;
};


export type MutationUpdateHubPageArgs = {
  companyID: Scalars['ID']['input'];
  input: HubPageUpdateInput;
};


export type MutationUpdateLocalOrderConfigurationArgs = {
  branchId: Scalars['ID']['input'];
  data: LocalOrderConfigurationUpdateInput;
};


export type MutationUpdateMenuArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMenu;
};


export type MutationUpdateMenuPreviewArgs = {
  input: MenuPreviewUpdate;
};


export type MutationUpdateMenuProductArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<UpdateMenuProduct>;
};


export type MutationUpdateMenuProductConfigurationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProductConfiguration;
};


export type MutationUpdateMenuProductConfigurationValueArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMenuProductConfigurationValue;
};


export type MutationUpdateMenuSectionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateMenuSection;
  timeRuleInput: UpdateMenuSectionTimeRule;
};


export type MutationUpdateNewsBannerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateNewsBannerInput;
};


export type MutationUpdateOnlineOrderConfigurationArgs = {
  branchID: Scalars['ID']['input'];
  input: UpdateOnlineOrderConfigurationInput;
};


export type MutationUpdateOpeningTimeArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOpeningTimeData;
};


export type MutationUpdatePageRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePageRuleInput;
};


export type MutationUpdatePrintRuleArgs = {
  id: Scalars['ID']['input'];
  input: UpdatePrintRuleInput;
};


export type MutationUpdatePrinterDeviceArgs = {
  data: UpdatePrinterDeviceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateScheduleAvailabilityLimitationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateScheduledAvailabilityLimitationInput;
  timeRuleInput: ScheduledLimitationTimeRuleInput;
};


export type MutationUpdateServiceMenuSectionArgs = {
  id: Scalars['ID']['input'];
  input: UpdateServiceMenuSection;
  timeRuleInput: UpdateMenuSectionTimeRule;
};


export type MutationUpdateSimpleUserArgs = {
  id: Scalars['ID']['input'];
  input: SimpleUserUpdate;
};


export type MutationUpdateStripeApiKeyArgs = {
  id: Scalars['String']['input'];
  input: UpdateStripeApiKeyInput;
};


export type MutationUpdateTableArgs = {
  data?: InputMaybe<UpdateTable>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTableBatchArgs = {
  data: Array<BatchUpdateTableEntry>;
};


export type MutationUpdateTableGroupArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTableGroup;
};


export type MutationUpdateTableReservationArgs = {
  id: Scalars['ID']['input'];
  input: TableReservationUpdate;
};


export type MutationUpdateTableReservationConfigurationArgs = {
  id: Scalars['ID']['input'];
  input: TableReservationConfigurationUpdateInput;
};


export type MutationUpdateTableReservationConfirmationStatusArgs = {
  id: Scalars['ID']['input'];
  status: TableReservationConfirmationStatus;
};


export type MutationUpdateTableReservationStatusArgs = {
  id: Scalars['ID']['input'];
  status: TableReservationStatus;
};


export type MutationUpdateTableReservationTableArgs = {
  id: Scalars['ID']['input'];
  tableId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateTableReservationV2Args = {
  id: Scalars['ID']['input'];
  input: TableReservationUpdateV2;
};


export type MutationUpdateTeamArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTeamInput;
  memberTeam: Array<TeamMemberUpdateInput>;
};


export type MutationUpdateTemporaryAvailabilityLimitationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTemporaryAvailabilityLimitationInput;
};


export type MutationUpdateTopBannerArgs = {
  id: Scalars['ID']['input'];
  input: UpdateTopBannerInput;
};


export type MutationUpdateUserArgs = {
  data?: InputMaybe<UpdateUserData>;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserNotificationArgs = {
  id: Scalars['ID']['input'];
  input: UserNotificationInput;
};


export type MutationUserCompanyRoleCreateArgs = {
  companyID: Scalars['ID']['input'];
  input: UserCompanyRoleCreate;
};


export type MutationUserCompanyRoleDeleteArgs = {
  companyID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};


export type MutationUserCompanyRoleUpdateArgs = {
  companyID: Scalars['ID']['input'];
  input: UserCompanyRoleUpdate;
};


export type MutationValidateStripeApiKeyArgs = {
  publishableKey: Scalars['String']['input'];
  secretKey: Scalars['String']['input'];
};

export type NailAppointment = {
  __typename?: 'NailAppointment';
  branchId: Scalars['ID']['output'];
  cancelReason?: Maybe<CancelReason>;
  confirmationStatus: NailAppointmentConfirmationStatus;
  createAt: Scalars['DateTime']['output'];
  customerVariant: CustomerVariant;
  customerVariantId: Scalars['ID']['output'];
  deleted: Scalars['Boolean']['output'];
  employees: Array<PickedNailAppointmentEmployee>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  products: Array<PickedNailAppointmentProduct>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  teams: Array<PickedNailAppointmentTeam>;
  updateAt: Scalars['DateTime']['output'];
};

export enum NailAppointmentConfirmationStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Waiting = 'WAITING'
}

export type NailAppointmentFilter = {
  confirmationStatus?: InputMaybe<NailAppointmentConfirmationStatus>;
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type NailAppointmentMenuProduct = {
  __typename?: 'NailAppointmentMenuProduct';
  allergics: Scalars['String']['output'];
  appointmentMenuProductData: NailAppointmentProductData;
  code: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  configurations: Array<MenuProductConfiguration>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  inStock?: Maybe<Scalars['Boolean']['output']>;
  ingredients: Array<Scalars['String']['output']>;
  labels?: Maybe<Array<MenuProductLabel>>;
  menuId: Scalars['String']['output'];
  priceMode: MenuProductPriceMode;
  section?: Maybe<MenuSection>;
  sectionId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type NailAppointmentMenuProductDataTeam = {
  __typename?: 'NailAppointmentMenuProductDataTeam';
  id: Scalars['ID']['output'];
  menuProductDataId: Scalars['ID']['output'];
  team: Team;
  teamId: Scalars['String']['output'];
};

export type NailAppointmentOverviewMetrics = {
  __typename?: 'NailAppointmentOverviewMetrics';
  averageRevenuePerAppointment: Scalars['Float']['output'];
  bookingPerformanceRate: Scalars['Float']['output'];
  totalConfirmedAppointments: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type NailAppointmentProductData = {
  __typename?: 'NailAppointmentProductData';
  duration: Scalars['Int']['output'];
  menuProductId: Scalars['ID']['output'];
  nailAppointmentMenuProductTeams: Array<NailAppointmentMenuProductDataTeam>;
};

export type NailsAppointmentData = {
  __typename?: 'NailsAppointmentData';
  appointmentId: Scalars['String']['output'];
  createAt: Scalars['String']['output'];
  serviceName: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type NewCustomersByDayResult = {
  __typename?: 'NewCustomersByDayResult';
  date: Scalars['String']['output'];
  newCustomers: Scalars['Int']['output'];
};

export type NewCustomersByWeekResult = {
  __typename?: 'NewCustomersByWeekResult';
  newCustomers: Scalars['Int']['output'];
  week: Scalars['String']['output'];
};

export type NewsBanner = Banner & {
  __typename?: 'NewsBanner';
  allowPopup: Scalars['Boolean']['output'];
  clickCount: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  platforms: Array<BannerPlatform>;
  startTime: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewCount: Scalars['Int']['output'];
};

export type NewsBannerFilterInput = {
  allowPopup?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  platforms?: InputMaybe<Array<BannerPlatform>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BannerStatus>;
};

export enum NotificationEntityType {
  NailsAppointment = 'NAILS_APPOINTMENT',
  OnlineOrder = 'ONLINE_ORDER',
  TableReservation = 'TABLE_RESERVATION'
}

export type OnlineOrder = {
  __typename?: 'OnlineOrder';
  /** @deprecated This field will be deprecated. Please use the summary field instead. */
  _count: OnlineOrderCount;
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLocality?: Maybe<Scalars['String']['output']>;
  addressRegion?: Maybe<Scalars['String']['output']>;
  basePrice?: Maybe<Scalars['Int']['output']>;
  branch: Branch;
  confirmationState: OnlineOrderConfirmationState;
  createdAt: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  deliveryDiscount?: Maybe<Scalars['Int']['output']>;
  deliveryFeeCalculationStatus: OnlineOrderDeliveryFeeCalculationStatus;
  deliveryMode: OnlineOrderDeliveryMode;
  deliveryPrice?: Maybe<Scalars['Int']['output']>;
  distanceToRestaurant?: Maybe<Scalars['Float']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  estimatedDuration?: Maybe<Scalars['Int']['output']>;
  events: Array<OnlineOrderStateEvent>;
  expectedTime?: Maybe<Scalars['DateTime']['output']>;
  guestName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Invoice>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  manualTransferConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  manualTransferConfirmedById?: Maybe<Scalars['String']['output']>;
  manualTransferProofImageOrigin?: Maybe<Scalars['String']['output']>;
  manualTransferProofImageThumbnail?: Maybe<Scalars['String']['output']>;
  manualTransferProofSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  manualTransferRejectedAt?: Maybe<Scalars['DateTime']['output']>;
  manualTransferRejectionReason?: Maybe<Scalars['String']['output']>;
  manualTransferSenderName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  onlineOrderProducts: Array<OnlineOrderProduct>;
  paymentMethod?: Maybe<OnlineOrderPaymentMethod>;
  phone?: Maybe<Scalars['String']['output']>;
  pickupDiscount?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  shortID: Scalars['ID']['output'];
  state: OnlineOrderState;
  streetAddress?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  /** Summary of the online order */
  summary: OnlineOrderSummary;
  tags: Array<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userCreatedAt: Scalars['DateTime']['output'];
  userState: OnlineOrderUserState;
};

export type OnlineOrderAvailability = {
  __typename?: 'OnlineOrderAvailability';
  delivery: OnlineOrderServiceAvailability;
  pickup: OnlineOrderServiceAvailability;
};

export type OnlineOrderBranchConfiguration = {
  __typename?: 'OnlineOrderBranchConfiguration';
  autoDeliveryConfirm: Scalars['Boolean']['output'];
  autoPickupConfirm: Scalars['Boolean']['output'];
  branchID: Scalars['ID']['output'];
  capacityEnabled: Scalars['Boolean']['output'];
  categoryStyle: CategoryStyle;
  defaultPreparingTime: Scalars['Int']['output'];
  deliveryDiscountAmount: Scalars['Int']['output'];
  deliveryDiscountType: DeliveryDiscountType;
  deliveryEnable: Scalars['Boolean']['output'];
  deliveryPause: Scalars['Boolean']['output'];
  deliveryPauseReactiveTimestamp?: Maybe<Scalars['DateTime']['output']>;
  deliveryRadiusLimit: Scalars['Int']['output'];
  deliveryTableData?: Maybe<Array<OnlineOrderDeliveryTableConfiguration>>;
  happyHourMode?: Maybe<HappyHourMode>;
  menu?: Maybe<Menu>;
  menuID?: Maybe<Scalars['ID']['output']>;
  minimumOrderAmountForDelivery: Scalars['Int']['output'];
  onlinePaymentMethods: Array<OnlinePaymentMethod>;
  paymentMethods: Array<OnlineOrderPaymentMethod>;
  pickupDiscountAmount: Scalars['Int']['output'];
  pickupDiscountType: PickupDiscountType;
  pickupEnable: Scalars['Boolean']['output'];
  pickupPause: Scalars['Boolean']['output'];
  pickupReactiveTimestamp?: Maybe<Scalars['DateTime']['output']>;
  printToKitchen: Scalars['Boolean']['output'];
  stripeAPIKeyId?: Maybe<Scalars['String']['output']>;
  template?: Maybe<OnlineOrderTemplate>;
};

export enum OnlineOrderConfirmationState {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export type OnlineOrderCount = {
  __typename?: 'OnlineOrderCount';
  onlineOrderProducts: Scalars['Int']['output'];
};

export type OnlineOrderCreateInput = {
  customerLanguage?: InputMaybe<Scalars['String']['input']>;
  initialDeliveryMode?: InputMaybe<OnlineOrderDeliveryMode>;
  pickedProducts: Array<OnlineOrderPickedProductInput>;
};

export type OnlineOrderDashboardFilter = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type OnlineOrderData = {
  __typename?: 'OnlineOrderData';
  createAt: Scalars['String']['output'];
  estimatedTime?: Maybe<Scalars['String']['output']>;
  guestName: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  orderShortId: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export enum OnlineOrderDeliveryFeeCalculationStatus {
  Calculated = 'CALCULATED',
  Failed = 'FAILED',
  NotCalculated = 'NOT_CALCULATED',
  OutOfRange = 'OUT_OF_RANGE'
}

export enum OnlineOrderDeliveryMode {
  Delivery = 'DELIVERY',
  Pickup = 'PICKUP'
}

export type OnlineOrderDeliveryTableConfiguration = {
  __typename?: 'OnlineOrderDeliveryTableConfiguration';
  deliveryDistance: Scalars['Int']['output'];
  deliveryFee: Scalars['Int']['output'];
  deliveryTime: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  minimumOrderBasePrice?: Maybe<Scalars['Int']['output']>;
};

export type OnlineOrderDeliveryTableConfigurationInput = {
  deliveryDistance: Scalars['Int']['input'];
  deliveryFee: Scalars['Int']['input'];
  deliveryTime: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  minimumOrderBasePrice?: InputMaybe<Scalars['Int']['input']>;
};

export type OnlineOrderFilter = {
  confirmationState?: InputMaybe<OnlineOrderConfirmationState>;
  deliveryMode?: InputMaybe<OnlineOrderDeliveryMode>;
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
  state?: InputMaybe<OnlineOrderState>;
  userState?: InputMaybe<OnlineOrderUserState>;
};

export type OnlineOrderHappyHour = {
  __typename?: 'OnlineOrderHappyHour';
  branches: Array<BranchOnlineOrderHappyHour>;
  createdAt: Scalars['DateTime']['output'];
  deliveryType: Array<HappyHourDeliveryType>;
  discountAmount: Scalars['Int']['output'];
  discountType: HappyHourDiscountType;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  minimumOrderAmount: Scalars['Int']['output'];
  timeRule: MenuSectionTimeRuleUnion;
  updatedAt: Scalars['DateTime']['output'];
};

export type OnlineOrderOwnerConfirmInput = {
  preparingTime?: InputMaybe<Scalars['Int']['input']>;
};

export type OnlineOrderOwnerStartCookingInput = {
  preparingTime: Scalars['Int']['input'];
};

export enum OnlineOrderPaymentMethod {
  Cash = 'CASH',
  ManualBankTransfer = 'MANUAL_BANK_TRANSFER',
  Stripe = 'STRIPE'
}

export type OnlineOrderPickedProductInput = {
  configurations: Array<OnlineOrderProductConfigurationInput>;
  productID: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};

export type OnlineOrderProduct = {
  __typename?: 'OnlineOrderProduct';
  configurations: Array<OnlineOrderProductConfiguration>;
  discountable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  menuProduct?: Maybe<MenuProduct>;
  quantity: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type OnlineOrderProductConfiguration = {
  __typename?: 'OnlineOrderProductConfiguration';
  id: Scalars['ID']['output'];
  menuProductConfigurationId?: Maybe<Scalars['ID']['output']>;
  menuProductConfigurationValueId?: Maybe<Scalars['ID']['output']>;
  price: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: ProductConfigurationType;
  value: Scalars['String']['output'];
};

export type OnlineOrderProductConfigurationInput = {
  configurationID: Scalars['ID']['input'];
  valueID: Scalars['ID']['input'];
};

export type OnlineOrderReportDateRangeInput = {
  endDate: Scalars['Date']['input'];
  startDate: Scalars['Date']['input'];
};

export type OnlineOrderReportDeliveryOverviewMetrics = {
  __typename?: 'OnlineOrderReportDeliveryOverviewMetrics';
  deliveryRevenue: Scalars['Float']['output'];
  pickupRevenue: Scalars['Float']['output'];
  totalDeliveryOrders: Scalars['Int']['output'];
  totalPickupOrders: Scalars['Int']['output'];
};

export type OnlineOrderReportHourlyOrderDistributionItem = {
  __typename?: 'OnlineOrderReportHourlyOrderDistributionItem';
  hour: Scalars['Int']['output'];
  orderCount: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
};

export type OnlineOrderReportOverviewMetrics = {
  __typename?: 'OnlineOrderReportOverviewMetrics';
  averageRevenuePerOrder: Scalars['Float']['output'];
  canceledOrders: Scalars['Int']['output'];
  totalOrders: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type OnlineOrderReportPaymentMethodMetrics = {
  __typename?: 'OnlineOrderReportPaymentMethodMetrics';
  cashOrders: Scalars['Int']['output'];
  stripeOrders: Scalars['Int']['output'];
  stripeRate: Scalars['Float']['output'];
  totalOrders: Scalars['Int']['output'];
};

export type OnlineOrderReportTopProductItem = {
  __typename?: 'OnlineOrderReportTopProductItem';
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  totalQuantitySold: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type OnlineOrderServiceAvailability = {
  __typename?: 'OnlineOrderServiceAvailability';
  now: Scalars['Boolean']['output'];
  orderForLater: Array<OnlineOrderTimeSlot>;
};

export type OnlineOrderServiceAvailable = {
  __typename?: 'OnlineOrderServiceAvailable';
  deliveryAvailable: Scalars['Boolean']['output'];
  pickupAvailable: Scalars['Boolean']['output'];
};

export enum OnlineOrderState {
  Canceled = 'CANCELED',
  Done = 'DONE',
  InProgress = 'IN_PROGRESS',
  WaitingForConfirmation = 'WAITING_FOR_CONFIRMATION',
  WaitingToCook = 'WAITING_TO_COOK'
}

export type OnlineOrderStateEvent = {
  __typename?: 'OnlineOrderStateEvent';
  id: Scalars['ID']['output'];
  state: OnlineOrderState;
  timestamp: Scalars['DateTime']['output'];
};

export type OnlineOrderSummary = {
  __typename?: 'OnlineOrderSummary';
  itemsCount: Scalars['Int']['output'];
};

export enum OnlineOrderTemplate {
  Classic = 'CLASSIC',
  Default = 'DEFAULT',
  Sushi = 'SUSHI'
}

export type OnlineOrderTimeSlot = {
  __typename?: 'OnlineOrderTimeSlot';
  spotsOpen: Scalars['Int']['output'];
  spotsTotal?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['DateTime']['output'];
};

export type OnlineOrderUpdateEvent = {
  __typename?: 'OnlineOrderUpdateEvent';
  branchID: Scalars['ID']['output'];
  onlineOrderID: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
};

export enum OnlineOrderUserState {
  Done = 'DONE',
  FillContactInfo = 'FILL_CONTACT_INFO',
  PickingProduct = 'PICKING_PRODUCT',
  Review = 'REVIEW',
  WaitingForManualConfirm = 'WAITING_FOR_MANUAL_CONFIRM',
  WaitingForPayment = 'WAITING_FOR_PAYMENT'
}

export type OnlinePaymentMethod = {
  __typename?: 'OnlinePaymentMethod';
  fields: Array<OnlinePaymentMethodField>;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  qrImageOrigin?: Maybe<Scalars['String']['output']>;
  qrImageThumbnail?: Maybe<Scalars['String']['output']>;
};

export type OnlinePaymentMethodField = {
  __typename?: 'OnlinePaymentMethodField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OnlinePaymentMethodFieldInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type OnlinePaymentMethodInput = {
  fields: Array<OnlinePaymentMethodFieldInput>;
  id: Scalars['ID']['input'];
  instructions?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  qrImageOrigin?: InputMaybe<Scalars['String']['input']>;
  qrImageThumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type OpeningTime = {
  __typename?: 'OpeningTime';
  branch: Branch;
  branchId: Scalars['String']['output'];
  closeTime: Scalars['String']['output'];
  dayOfWeek: DaysOfWeek;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  openTime: Scalars['String']['output'];
  service: OpeningTimeServiceType;
};

export type OpeningTimeFilter = {
  dayOfWeek?: InputMaybe<DaysOfWeek>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  service?: InputMaybe<OpeningTimeServiceType>;
};

export enum OpeningTimeServiceType {
  Appointment = 'APPOINTMENT',
  Location = 'LOCATION',
  OnlineOrderDelivery = 'ONLINE_ORDER_DELIVERY',
  OnlineOrderPickup = 'ONLINE_ORDER_PICKUP',
  TableReservation = 'TABLE_RESERVATION'
}

export type OrderItemInput = {
  id: Scalars['ID']['input'];
  orderIndex: Scalars['Int']['input'];
};

export type PaymentMethodMetrics = {
  __typename?: 'PaymentMethodMetrics';
  cashOrders: Scalars['Int']['output'];
  creditCardOrders: Scalars['Int']['output'];
  creditCardRate: Scalars['Float']['output'];
  totalOrders: Scalars['Int']['output'];
};

export type PickedConfiguration = {
  configurationID: Scalars['ID']['input'];
  valueID: Scalars['ID']['input'];
};

export type PickedNailAppointmentEmployee = {
  __typename?: 'PickedNailAppointmentEmployee';
  appointmentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  user: UserSnapshot;
  userId: Scalars['String']['output'];
};

export type PickedNailAppointmentProduct = {
  __typename?: 'PickedNailAppointmentProduct';
  appointmentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pickedProduct: MenuProductSnapshot;
};

export type PickedNailAppointmentTeam = {
  __typename?: 'PickedNailAppointmentTeam';
  appointmentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  team: Team;
  teamId: Scalars['String']['output'];
  teamName: Scalars['String']['output'];
};

export type PickedProductInput = {
  pickedConfiguration: Array<PickedConfiguration>;
  productID: Scalars['ID']['input'];
};

export enum PickupDiscountType {
  Amount = 'AMOUNT',
  None = 'NONE',
  Percentage = 'PERCENTAGE'
}

export enum PlatformType {
  System = 'SYSTEM'
}

export type PreSignImageUpload = {
  __typename?: 'PreSignImageUpload';
  origin: Scalars['String']['output'];
  originPath: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  thumbnailPath: Scalars['String']['output'];
};

export type PreSignPdfUpload = {
  __typename?: 'PreSignPdfUpload';
  path: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PrinterDevice = {
  __typename?: 'PrinterDevice';
  branch: Branch;
  branchId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  epsonPrinterDevice?: Maybe<EpsonPrinterDevice>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type ProductConfigurationSnapshot = {
  __typename?: 'ProductConfigurationSnapshot';
  id: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum ProductConfigurationType {
  Base = 'BASE',
  Option = 'OPTION',
  Selection = 'SELECTION'
}

export type QrCode = {
  __typename?: 'QRCode';
  qrCode: Scalars['String']['output'];
  tableId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
  allergies: Array<Allergy>;
  allergy: Allergy;
  analytic__invoice_aggregated_report_by_date: AggregatedInvoiceReport;
  analytic__invoice_report: InvoiceReport;
  analytic_customerSummary: CustomerSummaryResult;
  analytic_digitalMenu_getHourlyDistribution: Array<HourlyOrderDistributionItem>;
  analytic_digitalMenu_getOverviewMetrics: DigitalMenuOverviewMetrics;
  analytic_digitalMenu_getPaymentMethodMetrics: PaymentMethodMetrics;
  analytic_digitalMenu_getTopDishes: Array<TopDishItem>;
  analytic_hourlyReservations: Array<CountReportByHour>;
  analytic_nailAppointment_getCustomerSummary: CustomerSummaryMetrics;
  analytic_nailAppointment_getHourlyDistribution: Array<HourlyDistributionItem>;
  analytic_nailAppointment_getOverviewMetrics: NailAppointmentOverviewMetrics;
  analytic_nailAppointment_getTopEmployees: Array<TopEmployeeItem>;
  analytic_nailAppointment_getTopServices: Array<TopServiceItem>;
  analytic_newCustomersByDay: Array<NewCustomersByDayResult>;
  analytic_newCustomersByWeek: Array<NewCustomersByWeekResult>;
  analytic_reservation_getOverviewMetrics: ReservationMetric;
  analytic_reservation_hourlyDistribution: Array<HourlyDistributionResult>;
  analytic_reservationsByConfirmationStatus: Array<ReservationStatusCount>;
  analytic_reservationsByGuestCount: Array<ReservationsByGuestCount>;
  analytic_returningCustomersByDay: Array<ReturningCustomersByDayResult>;
  analytic_totalReservations: TotalReservationResult;
  appointmentBranchConfiguration: AppointmentBranchConfiguration;
  appointmentMenuProduct: NailAppointmentMenuProduct;
  appointmentMenuProducts: Array<NailAppointmentMenuProduct>;
  branch: Branch;
  branches: Array<Branch>;
  checkLocalOrderConfigurationExist: Scalars['Boolean']['output'];
  checkOverlapService: CheckOverlapServiceResult;
  checkPrintRuleAssignment?: Maybe<MenuPrintRuleAssignment>;
  companies: Array<Company>;
  company?: Maybe<Company>;
  companyContractStatus: Array<CompanyContractStatus>;
  companyCount: Scalars['Int']['output'];
  companyFeature: CompanyFeature;
  companyFeatures: Array<CompanyFeature>;
  companySettings?: Maybe<CompanySettings>;
  contract: CompanyContract;
  contractCategories?: Maybe<Array<CompanyContractCategory>>;
  contractFee: CompanyContractFee;
  contractFees: Array<CompanyContractFee>;
  contractWithAllFees: CompanyContract;
  contracts: Array<CompanyContractWithStatus>;
  currentUser?: Maybe<User>;
  customer: Customer;
  customerAppointmentHistory: Array<CustomerAppointmentHistoryResult>;
  customerCount: Scalars['Int']['output'];
  customers: Array<Customer>;
  customers_v2: Array<Customer>;
  digitalMenu_getCurrentMenu: Storefront_Menu;
  epsonPrinterDevices: Array<EpsonPrinterDevice>;
  epsonServerDirectPrint: EpsonServerDirectPrint;
  epsonServerDirectPrints: Array<EpsonServerDirectPrint>;
  getAvailableHappyHourByBranch: Array<OnlineOrderHappyHour>;
  getCancelReason: CancelReason;
  getCancelReasons: Array<CancelReason>;
  getCurrentAppointmentCapacity?: Maybe<Scalars['Int']['output']>;
  getCurrentOnlineOrderCapacity?: Maybe<Scalars['Int']['output']>;
  getCurrentTableReservationCapacity?: Maybe<Scalars['Int']['output']>;
  getHappyHour: OnlineOrderHappyHour;
  getHappyHours: Array<OnlineOrderHappyHour>;
  getPageListForRule: Array<MenuPrintPageRule>;
  getPrintRuleAssignment?: Maybe<MenuPrintRuleAssignment>;
  getPrintRuleList: Menu;
  getScheduleAvailabilityLimitationById: ScheduledAvailabilityLimitation;
  getScheduleAvailabilityLimitations: Array<ScheduledAvailabilityLimitation>;
  getTemporaryAvailabilityLimitationById?: Maybe<TemporaryAvailabilityLimitation>;
  getTemporaryAvailabilityLimitations: Array<TemporaryAvailabilityLimitation>;
  googleIntegrations: Array<GoogleIntegration>;
  googleOAuthUrl: Scalars['String']['output'];
  holiday: Holiday;
  holidays: Array<Holiday>;
  hubPageContent: HubPageContent;
  internalAPIKeys: Array<InternalApiKey>;
  invoice: Invoice;
  invoiceCount: Scalars['Int']['output'];
  invoicesByBranch: Array<Invoice>;
  invoicesByOrder: Array<Maybe<Invoice>>;
  landingPage_aboutUs?: Maybe<LandingPageAboutUs>;
  landingPage_aboutUsTranslations: Array<LandingPageAboutUsTranslation>;
  landingPage_founder?: Maybe<LandingPageFounder>;
  landingPage_founderTranslations: Array<LandingPageFounderTranslation>;
  landingPage_founders: Array<LandingPageFounder>;
  landingPage_heroBanner?: Maybe<LandingPageHeroBanner>;
  landingPage_heroBannerTranslations: Array<LandingPageHeroBannerTranslation>;
  landingPage_heroBanners: Array<LandingPageHeroBanner>;
  landingPage_language?: Maybe<LandingPage_Language>;
  landingPage_languages: Array<LandingPage_Language>;
  landingPage_service?: Maybe<LandingPageService>;
  landingPage_serviceContentBlock?: Maybe<LandingPageServiceContentBlock>;
  landingPage_serviceContentBlockTranslations: Array<LandingPageServiceContentBlockTranslation>;
  landingPage_serviceContentBlocks: Array<LandingPageServiceContentBlock>;
  landingPage_serviceTranslations: Array<LandingPageServiceTranslation>;
  landingPage_services: Array<LandingPageService>;
  landingPage_testimonial?: Maybe<LandingPageTestimonial>;
  landingPage_testimonialTranslations: Array<LandingPageTestimonialTranslation>;
  landingPage_testimonials: Array<LandingPageTestimonial>;
  localOrderConfiguration: LocalOrderConfiguration;
  localOrder_billSummary: LocalOrderBillSummary;
  localOrder_currentLocalOrderOnTable?: Maybe<LocalOrder>;
  localOrder_getItemRequest: Array<LocalOrderItemRequest>;
  localOrder_getLocalOrder: LocalOrder;
  localOrder_getLocalOrders: Array<LocalOrder>;
  localOrder_getLocalTable: Array<LocalOrderTable>;
  localOrder_getOrderOnTable: LocalOrder;
  localOrder_getProductList: Array<LocalOrderItemRequestProduct>;
  localOrder_guestBill: LocalOrderGuestBill;
  localOrder_guests: Array<LocalOrderGuest>;
  localOrder_history: Array<LocalOrder>;
  localOrder_itemRequestDashboard: Array<ItemRequestWithLocalOrderData>;
  loggerQuantity: Scalars['Int']['output'];
  loggers: Array<UserActivity>;
  menu: Menu;
  menuPreview: MenuPreview;
  menuProduct: MenuProduct;
  menuProductConfiguration?: Maybe<MenuProductConfiguration>;
  menuProductConfigurationValue?: Maybe<MenuProductConfigurationValue>;
  menuProductConfigurations: Array<MenuProductConfiguration>;
  menuSection: MenuSection;
  menuSections: Array<MenuSection>;
  menus: Array<Menu>;
  menus_v2: Array<Menu>;
  nailAppointment: NailAppointment;
  nailAppointments: Array<NailAppointment>;
  newsBanner: NewsBanner;
  newsBanners: Array<NewsBanner>;
  onlineOrder: OnlineOrder;
  onlineOrderBranchConfiguration?: Maybe<OnlineOrderBranchConfiguration>;
  onlineOrderReport_owner_getDeliveryOverview: OnlineOrderReportDeliveryOverviewMetrics;
  onlineOrderReport_owner_getHourlyDistribution: Array<OnlineOrderReportHourlyOrderDistributionItem>;
  onlineOrderReport_owner_getOverviewMetrics: OnlineOrderReportOverviewMetrics;
  onlineOrderReport_owner_getPaymentMethodMetrics: OnlineOrderReportPaymentMethodMetrics;
  onlineOrderReport_owner_getTopProducts: Array<OnlineOrderReportTopProductItem>;
  onlineOrdersDashboard: Array<OnlineOrder>;
  onlineOrdersHistory: Array<OnlineOrder>;
  openingTime: OpeningTime;
  openingTimes: Array<OpeningTime>;
  pageRule: MenuPrintPageRule;
  printRule: MenuPrintRule;
  printerDevices: Array<PrinterDevice>;
  pushNotificationTokens: Array<Scalars['String']['output']>;
  resolveStripeAPIStatus: StripeApiKeyStatus;
  searchCompanies: Array<Company>;
  serviceMenu: ServiceMenu;
  serviceMenuSection: ServiceMenuSection;
  serviceMenuSections: Array<ServiceMenuSection>;
  simpleCompanyUsers: Array<UserCompanyRole>;
  storefront_appointment: Storefront_Appointment;
  storefront_appointmentBranchConfiguration: AppointmentBranchConfiguration;
  storefront_branch?: Maybe<StoreFront_Branch>;
  storefront_company: Company;
  storefront_getAppointmentAvailability: AppointmentAvailability;
  storefront_getAvailableNewsBanner: Array<NewsBanner>;
  storefront_getAvailableTopBanner: Array<TopBanner>;
  storefront_getOnlineOrderAvailability: OnlineOrderAvailability;
  storefront_getTableReservationAvailability: ReservationAvailability;
  storefront_holidays: Array<Holiday>;
  storefront_isEachOnlineOrderServiceAvailable: OnlineOrderServiceAvailable;
  storefront_isHolidayNow: Scalars['Boolean']['output'];
  storefront_isOnlineOrderAvailable: Scalars['Boolean']['output'];
  storefront_isOnlineOrderOpen: Storefront_OnlineOrderOpenResult;
  storefront_isOpenNow: Scalars['Boolean']['output'];
  storefront_localOrder: Storefront_LocalOrder;
  storefront_localOrderConfiguration?: Maybe<LocalOrderConfiguration>;
  storefront_localOrder_activeLocalOrderOnTable: Storefront_LocalOrder;
  storefront_localOrder_billSummary: LocalOrderBillSummary;
  storefront_localOrder_myBill: LocalOrderGuestBill;
  storefront_onlineOrder?: Maybe<Storefront_OnlineOrder>;
  storefront_onlineOrderBranchConfiguration?: Maybe<Storefront_OnlineOrderBranchConfiguration>;
  storefront_onlineOrderBranchConfigurationByOrderID?: Maybe<Storefront_OnlineOrderBranchConfiguration>;
  storefront_openingTimes: Array<OpeningTime>;
  storefront_tableReservationBranches: Array<StoreFront_Branch>;
  storefront_tableReservationConfiguration: StorefrontTableReservationSetting;
  storefront_tableReservationOpeningTime: Array<OpeningTime>;
  storefront_tableReservationStatus: Storefront_TableReservation;
  stripeAPIKey: StripeApiKey;
  stripeAPIKeys: Array<StripeApiKey>;
  table?: Maybe<Table>;
  tableGroup?: Maybe<TableGroup>;
  tableGroups: Array<TableGroup>;
  tableReservation: TableReservation;
  tableReservationBranches: Array<TableReservationBranch>;
  tableReservationConfiguration: TableReservationSetting;
  tableReservationReport: TableReservationReport;
  tableReservations: Array<TableReservation>;
  tableReservationsCount: Scalars['Int']['output'];
  tableReservationsOperative: Array<TableReservation>;
  tables: Array<Table>;
  tablesByBranch: Array<Table>;
  team: Team;
  teams: Array<Team>;
  topBanner: TopBanner;
  topBanners: Array<TopBanner>;
  user?: Maybe<User>;
  userCompanyRole: UserCompanyRole;
  userCompanyRoles: Array<UserCompanyRole>;
  userCompanyRolesCount: Scalars['Int']['output'];
  userNotifications: Array<UserNotification>;
  users: Array<User>;
  usersCount: Scalars['Int']['output'];
  version?: Maybe<Scalars['String']['output']>;
};


export type QueryAllergiesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryAllergyArgs = {
  code: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
};


export type QueryAnalytic__Invoice_Aggregated_Report_By_DateArgs = {
  companyID: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryAnalytic__Invoice_ReportArgs = {
  companyID: Scalars['ID']['input'];
};


export type QueryAnalytic_CustomerSummaryArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_DigitalMenu_GetHourlyDistributionArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_DigitalMenu_GetOverviewMetricsArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_DigitalMenu_GetPaymentMethodMetricsArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_DigitalMenu_GetTopDishesArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_HourlyReservationsArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  lastDayCount: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_NailAppointment_GetCustomerSummaryArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_NailAppointment_GetHourlyDistributionArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_NailAppointment_GetOverviewMetricsArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_NailAppointment_GetTopEmployeesArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_NailAppointment_GetTopServicesArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_NewCustomersByDayArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_NewCustomersByWeekArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_Reservation_GetOverviewMetricsArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_Reservation_HourlyDistributionArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_ReservationsByConfirmationStatusArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_ReservationsByGuestCountArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_ReturningCustomersByDayArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAnalytic_TotalReservationsArgs = {
  branchId: Scalars['ID']['input'];
  endTime: Scalars['DateTime']['input'];
  lastDayCount: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
};


export type QueryAppointmentBranchConfigurationArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryAppointmentMenuProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppointmentMenuProductsArgs = {
  menuID: Scalars['ID']['input'];
};


export type QueryBranchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBranchesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCheckLocalOrderConfigurationExistArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryCheckOverlapServiceArgs = {
  branchId: Scalars['ID']['input'];
  input: CheckOverlapServiceInput;
};


export type QueryCheckPrintRuleAssignmentArgs = {
  menuPrintRuleId: Scalars['ID']['input'];
};


export type QueryCompaniesArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyContractStatusArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryCompanyFeatureArgs = {
  companyId: Scalars['ID']['input'];
  name: Feature;
};


export type QueryCompanyFeaturesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCompanySettingsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractCategoriesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryContractFeeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractFeesArgs = {
  contractId: Scalars['ID']['input'];
};


export type QueryContractWithAllFeesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContractsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerAppointmentHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerCountArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCustomersArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryCustomers_V2Args = {
  companyId: Scalars['ID']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDigitalMenu_GetCurrentMenuArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryEpsonPrinterDevicesArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryEpsonServerDirectPrintArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEpsonServerDirectPrintsArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryGetAvailableHappyHourByBranchArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryGetCancelReasonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCurrentAppointmentCapacityArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryGetCurrentOnlineOrderCapacityArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryGetCurrentTableReservationCapacityArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryGetHappyHourArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetHappyHoursArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryGetPageListForRuleArgs = {
  ruleId: Scalars['String']['input'];
};


export type QueryGetPrintRuleAssignmentArgs = {
  menuId: Scalars['ID']['input'];
  service: MenuPrintRuleService;
};


export type QueryGetPrintRuleListArgs = {
  menuId: Scalars['String']['input'];
};


export type QueryGetScheduleAvailabilityLimitationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetScheduleAvailabilityLimitationsArgs = {
  branchId: Scalars['ID']['input'];
  service: Service;
};


export type QueryGetTemporaryAvailabilityLimitationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTemporaryAvailabilityLimitationsArgs = {
  branchId: Scalars['ID']['input'];
  service: Service;
};


export type QueryGoogleIntegrationsArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryGoogleOAuthUrlArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryHolidayArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHolidaysArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryHubPageContentArgs = {
  branchID?: InputMaybe<Scalars['ID']['input']>;
  subDomain: Scalars['String']['input'];
};


export type QueryInvoiceArgs = {
  invoiceID: Scalars['ID']['input'];
};


export type QueryInvoiceCountArgs = {
  filter: InvoiceFilter;
};


export type QueryInvoicesByBranchArgs = {
  branchId: Scalars['ID']['input'];
  filter?: InputMaybe<InvoicesFilter>;
};


export type QueryInvoicesByOrderArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryLandingPage_AboutUsArgs = {
  lang: Scalars['String']['input'];
};


export type QueryLandingPage_FounderArgs = {
  id: Scalars['ID']['input'];
  lang: Scalars['String']['input'];
};


export type QueryLandingPage_FounderTranslationsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLandingPage_FoundersArgs = {
  lang: Scalars['String']['input'];
};


export type QueryLandingPage_HeroBannerArgs = {
  id: Scalars['ID']['input'];
  lang: Scalars['String']['input'];
};


export type QueryLandingPage_HeroBannerTranslationsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLandingPage_HeroBannersArgs = {
  lang: Scalars['String']['input'];
};


export type QueryLandingPage_LanguageArgs = {
  code: Scalars['String']['input'];
};


export type QueryLandingPage_LanguagesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLandingPage_ServiceArgs = {
  id: Scalars['ID']['input'];
  lang: Scalars['String']['input'];
};


export type QueryLandingPage_ServiceContentBlockArgs = {
  id: Scalars['ID']['input'];
  lang: Scalars['String']['input'];
};


export type QueryLandingPage_ServiceContentBlockTranslationsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLandingPage_ServiceContentBlocksArgs = {
  lang: Scalars['String']['input'];
  serviceId: Scalars['ID']['input'];
};


export type QueryLandingPage_ServiceTranslationsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLandingPage_ServicesArgs = {
  lang: Scalars['String']['input'];
};


export type QueryLandingPage_TestimonialArgs = {
  id: Scalars['ID']['input'];
  lang: Scalars['String']['input'];
};


export type QueryLandingPage_TestimonialTranslationsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLandingPage_TestimonialsArgs = {
  lang: Scalars['String']['input'];
};


export type QueryLocalOrderConfigurationArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryLocalOrder_BillSummaryArgs = {
  localOrderId: Scalars['ID']['input'];
};


export type QueryLocalOrder_CurrentLocalOrderOnTableArgs = {
  tableId: Scalars['ID']['input'];
};


export type QueryLocalOrder_GetItemRequestArgs = {
  localOrderId: Scalars['ID']['input'];
};


export type QueryLocalOrder_GetLocalOrderArgs = {
  localOrderId: Scalars['ID']['input'];
};


export type QueryLocalOrder_GetLocalOrdersArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryLocalOrder_GetLocalTableArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryLocalOrder_GetOrderOnTableArgs = {
  tableId: Scalars['ID']['input'];
};


export type QueryLocalOrder_GetProductListArgs = {
  localOrderId: Scalars['ID']['input'];
};


export type QueryLocalOrder_GuestBillArgs = {
  guestId: Scalars['ID']['input'];
  localOrderId: Scalars['ID']['input'];
};


export type QueryLocalOrder_GuestsArgs = {
  localOrderId: Scalars['ID']['input'];
};


export type QueryLocalOrder_HistoryArgs = {
  branchId: Scalars['ID']['input'];
  filter?: InputMaybe<LocalOrderHistoryFilter>;
};


export type QueryLocalOrder_ItemRequestDashboardArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryLoggerQuantityArgs = {
  companyId: Scalars['ID']['input'];
  loggerFilter?: InputMaybe<LoggerFilter>;
};


export type QueryLoggersArgs = {
  companyId: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  loggerFilter?: InputMaybe<LoggerFilter>;
  offset: Scalars['Int']['input'];
};


export type QueryMenuArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMenuPreviewArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryMenuProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMenuProductConfigurationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMenuProductConfigurationValueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMenuProductConfigurationsArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryMenuSectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMenuSectionsArgs = {
  menuId: Scalars['ID']['input'];
};


export type QueryMenusArgs = {
  companyId: Scalars['ID']['input'];
  menuSource: MenuSource;
};


export type QueryMenus_V2Args = {
  companyId: Scalars['ID']['input'];
  menuSources: Array<MenuSource>;
};


export type QueryNailAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNailAppointmentsArgs = {
  branchId: Scalars['ID']['input'];
  filter: NailAppointmentFilter;
};


export type QueryNewsBannerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsBannersArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryOnlineOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnlineOrderBranchConfigurationArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryOnlineOrderReport_Owner_GetDeliveryOverviewArgs = {
  branchId: Scalars['ID']['input'];
  dateRange: OnlineOrderReportDateRangeInput;
};


export type QueryOnlineOrderReport_Owner_GetHourlyDistributionArgs = {
  branchId: Scalars['ID']['input'];
  dateRange: OnlineOrderReportDateRangeInput;
};


export type QueryOnlineOrderReport_Owner_GetOverviewMetricsArgs = {
  branchId: Scalars['ID']['input'];
  dateRange: OnlineOrderReportDateRangeInput;
};


export type QueryOnlineOrderReport_Owner_GetPaymentMethodMetricsArgs = {
  branchId: Scalars['ID']['input'];
  dateRange: OnlineOrderReportDateRangeInput;
};


export type QueryOnlineOrderReport_Owner_GetTopProductsArgs = {
  branchId: Scalars['ID']['input'];
  dateRange: OnlineOrderReportDateRangeInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOnlineOrdersDashboardArgs = {
  branchID: Scalars['ID']['input'];
  filter: OnlineOrderDashboardFilter;
};


export type QueryOnlineOrdersHistoryArgs = {
  branchID: Scalars['ID']['input'];
  filter: OnlineOrderFilter;
};


export type QueryOpeningTimeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOpeningTimesArgs = {
  branchId: Scalars['ID']['input'];
  filter?: InputMaybe<OpeningTimeFilter>;
};


export type QueryPageRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPrintRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPrinterDevicesArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryResolveStripeApiStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchCompaniesArgs = {
  query: Scalars['String']['input'];
};


export type QueryServiceMenuArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceMenuSectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceMenuSectionsArgs = {
  menuId: Scalars['ID']['input'];
};


export type QuerySimpleCompanyUsersArgs = {
  companyID: Scalars['ID']['input'];
};


export type QueryStorefront_AppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorefront_AppointmentBranchConfigurationArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryStorefront_BranchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorefront_CompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorefront_GetAppointmentAvailabilityArgs = {
  at: Scalars['DateTime']['input'];
  branchId: Scalars['ID']['input'];
};


export type QueryStorefront_GetAvailableNewsBannerArgs = {
  companyId: Scalars['ID']['input'];
  filter: AvailableNewsBannerFilter;
};


export type QueryStorefront_GetAvailableTopBannerArgs = {
  companyId: Scalars['ID']['input'];
  filter: AvailableTopBannerFilter;
};


export type QueryStorefront_GetOnlineOrderAvailabilityArgs = {
  onlineOrderId: Scalars['ID']['input'];
};


export type QueryStorefront_GetTableReservationAvailabilityArgs = {
  at: Scalars['DateTime']['input'];
  branchId: Scalars['ID']['input'];
};


export type QueryStorefront_HolidaysArgs = {
  branchId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryStorefront_IsEachOnlineOrderServiceAvailableArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryStorefront_IsHolidayNowArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryStorefront_IsOnlineOrderAvailableArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryStorefront_IsOnlineOrderOpenArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryStorefront_IsOpenNowArgs = {
  branchID: Scalars['ID']['input'];
  service: Array<OpeningTimeServiceType>;
};


export type QueryStorefront_LocalOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorefront_LocalOrderConfigurationArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryStorefront_LocalOrder_ActiveLocalOrderOnTableArgs = {
  tableId: Scalars['ID']['input'];
};


export type QueryStorefront_LocalOrder_BillSummaryArgs = {
  localOrderId: Scalars['ID']['input'];
};


export type QueryStorefront_LocalOrder_MyBillArgs = {
  guestId: Scalars['ID']['input'];
  localOrderId: Scalars['ID']['input'];
};


export type QueryStorefront_OnlineOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorefront_OnlineOrderBranchConfigurationArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryStorefront_OnlineOrderBranchConfigurationByOrderIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStorefront_OpeningTimesArgs = {
  branchID: Scalars['ID']['input'];
  filter?: InputMaybe<OpeningTimeFilter>;
};


export type QueryStorefront_TableReservationBranchesArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryStorefront_TableReservationConfigurationArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryStorefront_TableReservationOpeningTimeArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryStorefront_TableReservationStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStripeApiKeyArgs = {
  id: Scalars['String']['input'];
};


export type QueryStripeApiKeysArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryTableArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTableGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTableGroupsArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryTableReservationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTableReservationBranchesArgs = {
  companyID: Scalars['ID']['input'];
};


export type QueryTableReservationConfigurationArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryTableReservationReportArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryTableReservationsArgs = {
  branchId: Scalars['ID']['input'];
  filter: TableReservationsFilter;
};


export type QueryTableReservationsCountArgs = {
  branchId: Scalars['ID']['input'];
  filter: TableReservationsFilter;
};


export type QueryTableReservationsOperativeArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryTablesArgs = {
  tableGroup: Scalars['ID']['input'];
};


export type QueryTablesByBranchArgs = {
  branchID: Scalars['ID']['input'];
};


export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamsArgs = {
  branchId: Scalars['ID']['input'];
};


export type QueryTopBannerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTopBannersArgs = {
  companyId: Scalars['ID']['input'];
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserCompanyRoleArgs = {
  companyID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};


export type QueryUserCompanyRolesArgs = {
  companyID: Scalars['ID']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryUserCompanyRolesCountArgs = {
  companyID: Scalars['ID']['input'];
};


export type QueryUserNotificationsArgs = {
  companyID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserFilter>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryUsersCountArgs = {
  filter?: InputMaybe<UserFilter>;
};

export type QuickSetupInput = {
  additionalAddress: Scalars['String']['input'];
  addressCountry: Scalars['String']['input'];
  addressLocality: Scalars['String']['input'];
  addressRegion: Scalars['String']['input'];
  businessEmail: Scalars['String']['input'];
  businessName: Scalars['String']['input'];
  businessPhone: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  openingTimes: QuickSetupOpeningTimesInput;
  postalCode: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  subDomain: Scalars['String']['input'];
  website: Scalars['String']['input'];
};

export type QuickSetupOpeningTimesInput = {
  closeTime: Scalars['String']['input'];
  closeTime2?: InputMaybe<Scalars['String']['input']>;
  daysOfWeek: Array<DaysOfWeek>;
  openTime: Scalars['String']['input'];
  openTime2?: InputMaybe<Scalars['String']['input']>;
};

export type QuickSetupResult = {
  __typename?: 'QuickSetupResult';
  company: Company;
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type ReservationAvailability = {
  __typename?: 'ReservationAvailability';
  slots: Array<ReservationTimeSlot>;
};

export type ReservationMetric = {
  __typename?: 'ReservationMetric';
  cancelledReservations: Scalars['Float']['output'];
  showUpRate: Scalars['Float']['output'];
  totalGuests: Scalars['Int']['output'];
  totalReservations: Scalars['Int']['output'];
};

export type ReservationStatusCount = {
  __typename?: 'ReservationStatusCount';
  count: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type ReservationTimeSlot = {
  __typename?: 'ReservationTimeSlot';
  spotsOpen: Scalars['Int']['output'];
  spotsTotal?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['DateTime']['output'];
};

export type ReservationsByGuestCount = {
  __typename?: 'ReservationsByGuestCount';
  count: Scalars['Int']['output'];
  guestCount: Scalars['Int']['output'];
};

export type ResetCurrentUserPasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ReturningCustomersByDayResult = {
  __typename?: 'ReturningCustomersByDayResult';
  date: Scalars['String']['output'];
  returningCustomers: Scalars['Int']['output'];
};

export type ScheduledAvailabilityLimitation = {
  __typename?: 'ScheduledAvailabilityLimitation';
  branchId: Scalars['ID']['output'];
  capacity: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  service: Service;
  timeRule: ScheduledLimitationTimeRule;
};

export type ScheduledLimitationTimeRule = {
  __typename?: 'ScheduledLimitationTimeRule';
  daysOfWeeks: Array<DaysOfWeek>;
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type ScheduledLimitationTimeRuleInput = {
  daysOfWeeks: Array<DaysOfWeek>;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export enum Service {
  NailAppointment = 'NAIL_APPOINTMENT',
  OnlineOrder = 'ONLINE_ORDER',
  TableReservation = 'TABLE_RESERVATION'
}

export type ServiceMenu = {
  __typename?: 'ServiceMenu';
  allergics: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  menuProducts: Array<NailAppointmentMenuProduct>;
  menuSource: MenuSource;
  preferredProductPriceMode: MenuProductPriceMode;
  sections: Array<MenuSection>;
  title: Scalars['String']['output'];
};

export type ServiceMenuSection = {
  __typename?: 'ServiceMenuSection';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  inStock: Scalars['Boolean']['output'];
  menuId: Scalars['String']['output'];
  menuProducts?: Maybe<Array<MenuProduct>>;
  name: Scalars['String']['output'];
  timeRule: MenuSectionTimeRuleUnion;
};

export type SetPrintRuleAssignmentInput = {
  checked: Scalars['Boolean']['input'];
  menuId: Scalars['String']['input'];
  menuPrintRuleId: Scalars['String']['input'];
  service: MenuPrintRuleService;
};

export type SimpleUserCreate = {
  colorCode: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
};

export type SimpleUserUpdate = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
};

export type StatusResult = {
  __typename?: 'StatusResult';
  status: Scalars['Boolean']['output'];
};

export type StoreFront_Branch = {
  __typename?: 'StoreFront_Branch';
  addressCountry: Scalars['String']['output'];
  addressLocality: Scalars['String']['output'];
  addressRegion: Scalars['String']['output'];
  company: Company;
  companyId: Scalars['String']['output'];
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  openingTimes?: Maybe<Array<OpeningTime>>;
  postalCode: Scalars['String']['output'];
  priceListLink?: Maybe<Scalars['String']['output']>;
  streetAddress: Scalars['String']['output'];
  tableReservationSetting: TableReservationSetting;
  timezone: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type StorefrontTableReservationSetting = {
  __typename?: 'StorefrontTableReservationSetting';
  branch: StoreFront_Branch;
  capacityEnabled: Scalars['Boolean']['output'];
  defaultBookingTimeDuration: Scalars['Int']['output'];
  flexDuration: Array<Scalars['Int']['output']>;
  flexEnabled: Scalars['Boolean']['output'];
  hourBlocking: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  pause: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  reservationLeadMinutes: Scalars['Int']['output'];
  reservationTraitMinutes: Scalars['Int']['output'];
  seatLimit: Scalars['Int']['output'];
  status: Scalars['Boolean']['output'];
};

export type Storefront_Appointment = {
  __typename?: 'Storefront_Appointment';
  branch?: Maybe<StoreFront_Branch>;
  branchId: Scalars['ID']['output'];
  confirmationStatus?: Maybe<AppointmentConfirmationStatus>;
  customerLanguage?: Maybe<Scalars['String']['output']>;
  customerVariant: CustomerVariant;
  deleted: Scalars['Boolean']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  platformType: PlatformType;
  products: Array<PickedNailAppointmentProduct>;
  startTime: Scalars['String']['output'];
};

export type Storefront_AppointmentStatusUpdateSubscribe = {
  __typename?: 'Storefront_AppointmentStatusUpdateSubscribe';
  appointment: Storefront_Appointment;
  event: SubscribeEvent;
};

export type Storefront_Company = {
  __typename?: 'Storefront_Company';
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  settings: Storefront_CompanySettings;
};

export type Storefront_CompanySettings = {
  __typename?: 'Storefront_CompanySettings';
  currency: Scalars['String']['output'];
  customerDefaultLanguage: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  timezone: Scalars['String']['output'];
};

export type Storefront_CreateAppointmentInput = {
  customerLanguage?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  receiveNewsletterPerEmail?: InputMaybe<Scalars['Boolean']['input']>;
  startTime: Scalars['String']['input'];
};

export type Storefront_LocalOrder = {
  __typename?: 'Storefront_LocalOrder';
  branchId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  guests: Array<LocalOrderGuest>;
  id: Scalars['ID']['output'];
  itemsRequests?: Maybe<Array<LocalOrderItemRequest>>;
  paymentMethod?: Maybe<LocalPaymentMethod>;
  serviceRequests?: Maybe<Array<LocalOrderRequest>>;
  state: LocalOrderState;
  table: Storefront_Table;
  tableId: Scalars['String']['output'];
  userState: LocalOrderUserState;
};

export type Storefront_Menu = {
  __typename?: 'Storefront_Menu';
  allergics: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  menuProducts: Array<Storefront_MenuProduct>;
  menuSource: MenuSource;
  preferredProductPriceMode: MenuProductPriceMode;
  sections: Array<MenuSection>;
  title: Scalars['String']['output'];
};

export type Storefront_MenuProduct = {
  __typename?: 'Storefront_MenuProduct';
  allergics: Array<Allergy>;
  code: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  configurations: Array<MenuProductConfiguration>;
  description: Scalars['String']['output'];
  discountable: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  images: Array<Scalars['String']['output']>;
  inStock: Scalars['Boolean']['output'];
  ingredients: Array<Scalars['String']['output']>;
  labels?: Maybe<Array<MenuProductLabel>>;
  menuId: Scalars['String']['output'];
  priceMode: MenuProductPriceMode;
  section?: Maybe<MenuSection>;
  sectionId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Storefront_OnlineOrder = {
  __typename?: 'Storefront_OnlineOrder';
  addressCountry?: Maybe<Scalars['String']['output']>;
  addressLocality?: Maybe<Scalars['String']['output']>;
  addressRegion?: Maybe<Scalars['String']['output']>;
  basePrice?: Maybe<Scalars['Int']['output']>;
  branch: StoreFront_Branch;
  confirmationState: OnlineOrderConfirmationState;
  createdAt: Scalars['DateTime']['output'];
  customerLanguage?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  deliveryDiscount?: Maybe<Scalars['Int']['output']>;
  deliveryFeeCalculationStatus: OnlineOrderDeliveryFeeCalculationStatus;
  deliveryMode?: Maybe<OnlineOrderDeliveryMode>;
  deliveryPrice?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  estimatedDuration?: Maybe<Scalars['Int']['output']>;
  events: Array<OnlineOrderStateEvent>;
  expectedTime?: Maybe<Scalars['DateTime']['output']>;
  guestName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Storefront_OnlineOrderInvoice>;
  manualTransferConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  manualTransferProofImageOrigin?: Maybe<Scalars['String']['output']>;
  manualTransferProofImageThumbnail?: Maybe<Scalars['String']['output']>;
  manualTransferProofSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  manualTransferRejectedAt?: Maybe<Scalars['DateTime']['output']>;
  manualTransferRejectionReason?: Maybe<Scalars['String']['output']>;
  manualTransferSenderName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  onlineOrderProducts: Array<OnlineOrderProduct>;
  paymentMethod?: Maybe<OnlineOrderPaymentMethod>;
  phone?: Maybe<Scalars['String']['output']>;
  pickupDiscount?: Maybe<Scalars['Int']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  shortID: Scalars['ID']['output'];
  state: OnlineOrderState;
  streetAddress?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  totalPrice?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  userState: OnlineOrderUserState;
};

export type Storefront_OnlineOrderBranchConfiguration = {
  __typename?: 'Storefront_OnlineOrderBranchConfiguration';
  autoDeliveryConfirm: Scalars['Boolean']['output'];
  autoPickupConfirm: Scalars['Boolean']['output'];
  branchID: Scalars['ID']['output'];
  capacityEnabled: Scalars['String']['output'];
  categoryStyle: CategoryStyle;
  defaultPreparingTime: Scalars['Int']['output'];
  deliveryDiscountAmount: Scalars['Int']['output'];
  deliveryDiscountType: DeliveryDiscountType;
  deliveryEnable: Scalars['Boolean']['output'];
  deliveryPause: Scalars['Boolean']['output'];
  deliveryPauseReactiveTimestamp?: Maybe<Scalars['DateTime']['output']>;
  deliveryRadiusLimit: Scalars['Int']['output'];
  deliveryTableData?: Maybe<Array<OnlineOrderDeliveryTableConfiguration>>;
  happyHourMode?: Maybe<HappyHourMode>;
  hourBlocking: Scalars['Int']['output'];
  menu?: Maybe<Storefront_Menu>;
  menuID?: Maybe<Scalars['ID']['output']>;
  minimumOrderAmountForDelivery: Scalars['Int']['output'];
  onlinePaymentMethods: Array<OnlinePaymentMethod>;
  paymentMethods: Array<OnlineOrderPaymentMethod>;
  pickupDiscountAmount: Scalars['Int']['output'];
  pickupDiscountType: PickupDiscountType;
  pickupEnable: Scalars['Boolean']['output'];
  pickupPause: Scalars['Boolean']['output'];
  pickupReactiveTimestamp?: Maybe<Scalars['DateTime']['output']>;
  template?: Maybe<OnlineOrderTemplate>;
};

export type Storefront_OnlineOrderInvoice = {
  __typename?: 'Storefront_OnlineOrderInvoice';
  id: Scalars['ID']['output'];
  paymentURL?: Maybe<Scalars['String']['output']>;
};

export type Storefront_OnlineOrderOpenResult = {
  __typename?: 'Storefront_OnlineOrderOpenResult';
  isDeliveryAvailable: Scalars['Boolean']['output'];
  isPickupAvailable: Scalars['Boolean']['output'];
};

export type Storefront_OnlineOrderUpdateEvent = {
  __typename?: 'Storefront_OnlineOrderUpdateEvent';
  onlineOrderID: Scalars['ID']['output'];
  timestamp: Scalars['String']['output'];
};

export type Storefront_PickedProductInput = {
  memberID?: InputMaybe<Scalars['ID']['input']>;
  pickedConfiguration: Array<PickedConfiguration>;
  productID: Scalars['ID']['input'];
};

export type Storefront_Table = {
  __typename?: 'Storefront_Table';
  createdAt: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  seats: Scalars['Int']['output'];
  tableGroup: Storefront_TableGroup;
  tableGroupId: Scalars['ID']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type Storefront_TableGroup = {
  __typename?: 'Storefront_TableGroup';
  arrangementCode?: Maybe<Scalars['String']['output']>;
  branch: StoreFront_Branch;
  branchId: Scalars['ID']['output'];
  gridLayout: GridLayout;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tables: Array<Table>;
};

export type Storefront_TableReservation = {
  __typename?: 'Storefront_TableReservation';
  branch: Branch;
  confirmationStatus: TableReservationConfirmationStatus;
  deleted: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  flexTime?: Maybe<Scalars['Int']['output']>;
  guestName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  seats: Scalars['Int']['output'];
  startTime: Scalars['DateTime']['output'];
  timezone: Scalars['String']['output'];
};

export type Storefront_TableReservationCreate = {
  customerLanguage: Scalars['String']['input'];
  email: Scalars['String']['input'];
  flexDuration?: InputMaybe<Scalars['Int']['input']>;
  guestName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  platformType: PlatformType;
  receiveNewsletterPerEmail: Scalars['Boolean']['input'];
  seats: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type Storefront_TableReservationStatusUpdateSubscribe = {
  __typename?: 'Storefront_TableReservationStatusUpdateSubscribe';
  event: SubscribeEvent;
  tableReservation: Storefront_TableReservation;
};

export type StripeApiKey = {
  __typename?: 'StripeAPIKey';
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publishableKey: Scalars['String']['output'];
  secretKey: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  webhookSecret?: Maybe<Scalars['String']['output']>;
};

export enum StripeApiKeyStatus {
  Active = 'ACTIVE',
  NonActive = 'NON_ACTIVE'
}

export type StripeApiKeyValidate = {
  __typename?: 'StripeAPIKeyValidate';
  publishableKey: Scalars['Boolean']['output'];
  secretKey: Scalars['Boolean']['output'];
};

export type StripeApiValidatedResult = {
  __typename?: 'StripeAPIValidatedResult';
  details: StripeApiKeyValidate;
  isValid: Scalars['Boolean']['output'];
};

export enum StripeCheckoutPaymentStatus {
  NoPaymentRequired = 'NO_PAYMENT_REQUIRED',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

export type StripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  invoice: Invoice;
  invoiceId: Scalars['ID']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentStatus: StripeCheckoutPaymentStatus;
  refund?: Maybe<StripeRefund>;
  status: StripeCheckoutStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export enum StripeCheckoutStatus {
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  Open = 'OPEN'
}

export type StripeRefund = {
  __typename?: 'StripeRefund';
  amount: Scalars['Int']['output'];
  chargeId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  currency: Scalars['String']['output'];
  destinationDetails?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  paymentIntentId: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SubmitManualTransferProofInput = {
  imageOriginPath: Scalars['String']['input'];
  imageThumbnailPath: Scalars['String']['input'];
  senderName: Scalars['String']['input'];
};

export enum SubscribeEvent {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

export type Subscription = {
  __typename?: 'Subscription';
  _empty?: Maybe<Scalars['String']['output']>;
  appointmentUpdateSubscribe: AppointmentBranchSubscribe;
  onUpdateDigitalMenu: Scalars['Boolean']['output'];
  onUpdateOnlineOrder: OnlineOrderUpdateEvent;
  storefront_appointmentStatusUpdateSubscribe: Storefront_AppointmentStatusUpdateSubscribe;
  storefront_onUpdateDigitalMenu: Scalars['Boolean']['output'];
  storefront_onUpdateOnlineOrder: Storefront_OnlineOrderUpdateEvent;
  storefront_tableReservationStatusUpdateSubscribe: Storefront_TableReservationStatusUpdateSubscribe;
  supported: Scalars['Boolean']['output'];
  tableReservationUpdateSubscribe: TableReservationBranchSubscribe;
};


export type SubscriptionAppointmentUpdateSubscribeArgs = {
  branchID: Scalars['ID']['input'];
};


export type SubscriptionOnUpdateDigitalMenuArgs = {
  branchId: Scalars['ID']['input'];
};


export type SubscriptionOnUpdateOnlineOrderArgs = {
  branchID: Scalars['ID']['input'];
};


export type SubscriptionStorefront_AppointmentStatusUpdateSubscribeArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionStorefront_OnUpdateDigitalMenuArgs = {
  branchId: Scalars['ID']['input'];
};


export type SubscriptionStorefront_OnUpdateOnlineOrderArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionStorefront_TableReservationStatusUpdateSubscribeArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionTableReservationUpdateSubscribeArgs = {
  branchId: Scalars['ID']['input'];
};

export type Table = {
  __typename?: 'Table';
  createdAt: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  seats: Scalars['Int']['output'];
  tableGroup?: Maybe<TableGroup>;
  tableGroupId: Scalars['ID']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type TableGridEntry = {
  __typename?: 'TableGridEntry';
  column: Scalars['Int']['output'];
  row: Scalars['Int']['output'];
  tableId: Scalars['ID']['output'];
};

export type TableGridEntryInput = {
  column: Scalars['Int']['input'];
  row: Scalars['Int']['input'];
  tableId: Scalars['ID']['input'];
};

export type TableGridLayout = {
  __typename?: 'TableGridLayout';
  columns: Scalars['Int']['output'];
  entries: Array<TableGridEntry>;
  rows: Scalars['Int']['output'];
};

export type TableGridLayoutInput = {
  columns: Scalars['Int']['input'];
  entries: Array<TableGridEntryInput>;
  rows: Scalars['Int']['input'];
};

export type TableGroup = {
  __typename?: 'TableGroup';
  arrangementCode?: Maybe<Scalars['String']['output']>;
  gridLayout: GridLayout;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  tables: Array<Table>;
};

export type TableReservation = {
  __typename?: 'TableReservation';
  branchId: Scalars['ID']['output'];
  cancelReason?: Maybe<CancelReason>;
  confirmationStatus: TableReservationConfirmationStatus;
  createAt: Scalars['DateTime']['output'];
  customerLanguage: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
  endTime?: Maybe<Scalars['DateTime']['output']>;
  flexTime?: Maybe<Scalars['Int']['output']>;
  guestName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  platformType: TableReservationSourceType;
  seats: Scalars['Int']['output'];
  startTime: Scalars['DateTime']['output'];
  status: TableReservationStatus;
  tableId?: Maybe<Scalars['ID']['output']>;
  tableReservationEvent: Array<TableReservationEvent>;
  timezone: Scalars['String']['output'];
  updateAt: Scalars['DateTime']['output'];
};

export type TableReservationBranch = {
  __typename?: 'TableReservationBranch';
  bookingTable: Scalars['Int']['output'];
  branchId: Scalars['ID']['output'];
  branchName: Scalars['String']['output'];
  tableReservationSettingId: Scalars['ID']['output'];
  tables: Scalars['Int']['output'];
};

export type TableReservationBranchSubscribe = {
  __typename?: 'TableReservationBranchSubscribe';
  event: SubscribeEvent;
  tableReservation: TableReservation;
};

export type TableReservationChange = {
  __typename?: 'TableReservationChange';
  key: Scalars['String']['output'];
  new?: Maybe<Scalars['String']['output']>;
  old?: Maybe<Scalars['String']['output']>;
};

export type TableReservationConfigurationUpdateInput = {
  autoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  capacityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  defaultBookingTimeDuration?: InputMaybe<Scalars['Int']['input']>;
  flexDuration?: InputMaybe<Array<Scalars['Int']['input']>>;
  flexEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  hourBlocking?: InputMaybe<Scalars['Int']['input']>;
  ignoreStatus?: InputMaybe<Scalars['Boolean']['input']>;
  notificationMails?: InputMaybe<Array<Scalars['String']['input']>>;
  pause?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  reminderTime?: InputMaybe<Scalars['Int']['input']>;
  reservationLeadMinutes?: InputMaybe<Scalars['Int']['input']>;
  reservationTraitMinutes?: InputMaybe<Scalars['Int']['input']>;
  seatLimit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TableReservationConfirmationStatus {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Waiting = 'WAITING'
}

export type TableReservationCreate = {
  email: Scalars['String']['input'];
  flexDuration?: InputMaybe<Scalars['Int']['input']>;
  guestName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  platformType: PlatformType;
  seats: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type TableReservationData = {
  __typename?: 'TableReservationData';
  createAt: Scalars['String']['output'];
  guestCount: Scalars['Int']['output'];
  reservationId: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  tableNumber?: Maybe<Scalars['String']['output']>;
};

export type TableReservationEvent = {
  __typename?: 'TableReservationEvent';
  author: Author;
  change: Array<TableReservationChange>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reservationId: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type TableReservationReport = {
  __typename?: 'TableReservationReport';
  daily: Array<CountReportByDate>;
  hourly: Array<CountReportByHour>;
};

export type TableReservationSetting = {
  __typename?: 'TableReservationSetting';
  autoConfirm: Scalars['Boolean']['output'];
  capacityEnabled: Scalars['Boolean']['output'];
  defaultBookingTimeDuration: Scalars['Int']['output'];
  flexDuration: Array<Scalars['Int']['output']>;
  flexEnabled: Scalars['Boolean']['output'];
  hourBlocking: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  ignoreStatus: Scalars['Boolean']['output'];
  notificationMails: Array<Scalars['String']['output']>;
  pause: Scalars['Boolean']['output'];
  phone: Scalars['String']['output'];
  reminderTime: Scalars['Int']['output'];
  reservationLeadMinutes: Scalars['Int']['output'];
  reservationTraitMinutes: Scalars['Int']['output'];
  seatLimit: Scalars['Int']['output'];
  status: Scalars['Boolean']['output'];
};

export enum TableReservationSourceType {
  System = 'SYSTEM'
}

export enum TableReservationStatus {
  Arrived = 'ARRIVED',
  Cancelled = 'CANCELLED',
  Done = 'DONE',
  WaitingGuest = 'WAITING_GUEST'
}

export type TableReservationUpdate = {
  email: Scalars['String']['input'];
  guestName: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  seats: Scalars['Int']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type TableReservationUpdateV2 = {
  email?: InputMaybe<Scalars['String']['input']>;
  guestName?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  updateMessage?: InputMaybe<Scalars['String']['input']>;
};

export type TableReservationsFilter = {
  confirmationStatus?: InputMaybe<TableReservationConfirmationStatus>;
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type Team = {
  __typename?: 'Team';
  branchId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  teamMember: Array<TeamMember>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  id: Scalars['ID']['output'];
  teamId: Scalars['String']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type TeamMemberCreateInput = {
  userId: Scalars['ID']['input'];
};

export type TeamMemberUpdateInput = {
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type TemporaryAvailabilityLimitation = {
  __typename?: 'TemporaryAvailabilityLimitation';
  branchId: Scalars['ID']['output'];
  capacity: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  service: Service;
  startTime: Scalars['DateTime']['output'];
};

export type TopBanner = Banner & {
  __typename?: 'TopBanner';
  backgroundColor: Scalars['String']['output'];
  clickCount: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  platforms: Array<BannerPlatform>;
  startTime: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  viewCount: Scalars['Int']['output'];
};

export type TopBannerFilterInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  platforms?: InputMaybe<Array<BannerPlatform>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BannerStatus>;
};

export type TopDishItem = {
  __typename?: 'TopDishItem';
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  totalQuantitySold: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type TopEmployeeItem = {
  __typename?: 'TopEmployeeItem';
  averageRating?: Maybe<Scalars['Float']['output']>;
  employeeId: Scalars['ID']['output'];
  employeeName: Scalars['String']['output'];
  totalAppointments: Scalars['Int']['output'];
  totalRevenue: Scalars['Float']['output'];
};

export type TopServiceItem = {
  __typename?: 'TopServiceItem';
  serviceId: Scalars['ID']['output'];
  serviceName: Scalars['String']['output'];
  totalRevenue: Scalars['Float']['output'];
  totalSold: Scalars['Int']['output'];
};

export type TotalReservationPerDate = {
  __typename?: 'TotalReservationPerDate';
  date: Scalars['String']['output'];
  totalReservations: Scalars['Int']['output'];
};

export type TotalReservationResult = {
  __typename?: 'TotalReservationResult';
  totalPerRangeTime: Scalars['Int']['output'];
  totalReservationPerDate: Array<TotalReservationPerDate>;
};

export type UpdateAboutUsInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Array<LocalizedAboutUsInput>>;
};

export type UpdateAllergyInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppointmentInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAppointmentMenuProductInput = {
  duration?: InputMaybe<Scalars['Int']['input']>;
  menuProduct: UpdateMenuProductInputForAppointment;
};

export type UpdateBranch = {
  addressCountry: Scalars['String']['input'];
  addressLocality: Scalars['String']['input'];
  addressRegion: Scalars['String']['input'];
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  priceListLink?: InputMaybe<Scalars['String']['input']>;
  streetAddress: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyInput = {
  category?: InputMaybe<Array<CompanyCategory>>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  googleLink?: InputMaybe<Scalars['String']['input']>;
  imprintCompanyName?: InputMaybe<Scalars['String']['input']>;
  imprintCompanyTaxId?: InputMaybe<Scalars['String']['input']>;
  imprintEmail?: InputMaybe<Scalars['String']['input']>;
  imprintOwner?: InputMaybe<Scalars['String']['input']>;
  imprintOwnerTaxId?: InputMaybe<Scalars['String']['input']>;
  imprintPhone?: InputMaybe<Scalars['String']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tiktokLink?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanySettings = {
  currency?: InputMaybe<Scalars['String']['input']>;
  customerDefaultLanguage?: InputMaybe<Scalars['String']['input']>;
  notificationEmails?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateEpsonServerDirectPrintInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFounderInput = {
  githubUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Array<LocalizedFounderInput>>;
  twitterUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHeroBannerInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Array<LocalizedTextInput>>;
};

export type UpdateHolidayInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateLanguageInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMenu = {
  allergics?: InputMaybe<Scalars['String']['input']>;
  preferredProductPriceMode?: InputMaybe<MenuProductPriceMode>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMenuProduct = {
  allergics?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  configurations: Array<MenuProductConfigurationUpdateInput>;
  description: Scalars['String']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  images: Array<Scalars['String']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  ingredients: Array<Scalars['String']['input']>;
  labels?: InputMaybe<Array<MenuProductLabel>>;
  priceMode: MenuProductPriceMode;
  sectionId?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateMenuProductConfigurationValue = {
  name: Scalars['String']['input'];
  price: Scalars['Int']['input'];
};

export type UpdateMenuProductInputForAppointment = {
  code?: InputMaybe<Scalars['String']['input']>;
  configurations?: InputMaybe<Array<MenuProductConfigurationUpdateInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  sectionID?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMenuSection = {
  code: Scalars['String']['input'];
  description: Scalars['String']['input'];
  discountable: Scalars['Boolean']['input'];
  enabled: Scalars['Boolean']['input'];
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateMenuSectionTimeRule = {
  daysOfWeek?: InputMaybe<Array<DaysOfWeek>>;
  end?: InputMaybe<Scalars['String']['input']>;
  isAllDays?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
  type: MenuSectionTimeRuleType;
};

export type UpdateNewsBannerInput = {
  allowPopup?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  platforms?: InputMaybe<Array<BannerPlatform>>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOnlineOrderConfigurationInput = {
  autoDeliveryConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  autoPickupConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  capacityEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  categoryStyle?: InputMaybe<CategoryStyle>;
  defaultPreparingTime?: InputMaybe<Scalars['Int']['input']>;
  deliveryDiscountAmount?: InputMaybe<Scalars['Int']['input']>;
  deliveryDiscountType?: InputMaybe<DeliveryDiscountType>;
  deliveryEnable?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryPause?: InputMaybe<Scalars['Boolean']['input']>;
  deliveryRadiusLimit?: InputMaybe<Scalars['Int']['input']>;
  deliveryTableData?: InputMaybe<Array<OnlineOrderDeliveryTableConfigurationInput>>;
  menuID?: InputMaybe<Scalars['ID']['input']>;
  minimumOrderAmountForDelivery?: InputMaybe<Scalars['Int']['input']>;
  onlinePaymentMethods?: InputMaybe<Array<OnlinePaymentMethodInput>>;
  paymentMethods?: InputMaybe<Array<OnlineOrderPaymentMethod>>;
  pickupDiscountAmount?: InputMaybe<Scalars['Int']['input']>;
  pickupDiscountType?: InputMaybe<PickupDiscountType>;
  pickupEnable?: InputMaybe<Scalars['Boolean']['input']>;
  pickupPause?: InputMaybe<Scalars['Boolean']['input']>;
  printToKitchen?: InputMaybe<Scalars['Boolean']['input']>;
  stripeAPIKeyId?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<OnlineOrderTemplate>;
};

export type UpdateOnlineOrderHappyHourInput = {
  branchIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  deliveryType?: InputMaybe<Array<HappyHourDeliveryType>>;
  discountAmount?: InputMaybe<Scalars['Int']['input']>;
  discountType?: InputMaybe<HappyHourDiscountType>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateOpeningTimeData = {
  closeTime: Scalars['String']['input'];
  dayOfWeek?: InputMaybe<DaysOfWeek>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  openTime: Scalars['String']['input'];
};

export type UpdatePageRuleInput = {
  allowedSections?: InputMaybe<Array<CreatePageSectionInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  printerDeviceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePrintRuleInput = {
  menuId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  printerDeviceId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePrinterDeviceInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductConfiguration = {
  title: Scalars['String']['input'];
  type: ProductConfigurationType;
};

export type UpdateScheduledAvailabilityLimitationInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceContentBlockInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Array<LocalizedServiceContentBlockInput>>;
};

export type UpdateServiceInput = {
  iconName?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  salePrice?: InputMaybe<Scalars['String']['input']>;
  translations?: InputMaybe<Array<LocalizedServiceInput>>;
};

export type UpdateServiceMenuSection = {
  code?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  inStock: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type UpdateStripeApiKeyInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishableKey?: InputMaybe<Scalars['String']['input']>;
  secretKey?: InputMaybe<Scalars['String']['input']>;
  webhookSecret?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTable = {
  name: Scalars['String']['input'];
  seats: Scalars['Int']['input'];
  tableGroupId: Scalars['ID']['input'];
};

export type UpdateTableGroup = {
  arrangementCode?: InputMaybe<Scalars['String']['input']>;
  gridLayout: GridLayoutInput;
  name: Scalars['String']['input'];
};

export type UpdateTeamInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemporaryAvailabilityLimitationInput = {
  capacity?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTestimonialInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Array<LocalizedTestimonialInput>>;
};

export type UpdateTopBannerInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  platforms?: InputMaybe<Array<BannerPlatform>>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserData = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  status: Scalars['Boolean']['input'];
  username: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  colorCode: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  role: Array<UserRole>;
  status: Scalars['Boolean']['output'];
  username: Scalars['String']['output'];
};

export type UserActivity = {
  __typename?: 'UserActivity';
  action: ActionType;
  companyId: Scalars['String']['output'];
  details: Scalars['JSON']['output'];
  entity: Entity;
  entityId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export enum UserCompanyPermission {
  ManageBanners = 'MANAGE_BANNERS',
  ManageBranches = 'MANAGE_BRANCHES',
  ManageCompany = 'MANAGE_COMPANY',
  ManageHubpage = 'MANAGE_HUBPAGE',
  ManageInvoices = 'MANAGE_INVOICES',
  ManageMenus = 'MANAGE_MENUS',
  ManageNailAppointment = 'MANAGE_NAIL_APPOINTMENT',
  ManageOnlineOrder = 'MANAGE_ONLINE_ORDER',
  ManageOnlineOrderBranchConfiguration = 'MANAGE_ONLINE_ORDER_BRANCH_CONFIGURATION',
  ManageOpeningTime = 'MANAGE_OPENING_TIME',
  ManageOrders = 'MANAGE_ORDERS',
  ManageOrdersAsClient = 'MANAGE_ORDERS_AS_CLIENT',
  ManageOrdersAsSelfService = 'MANAGE_ORDERS_AS_SELF_SERVICE',
  ManageOrdersAsWaiter = 'MANAGE_ORDERS_AS_WAITER',
  ManageProducts = 'MANAGE_PRODUCTS',
  ManageTables = 'MANAGE_TABLES',
  ManageTableReservation = 'MANAGE_TABLE_RESERVATION',
  ManageTeam = 'MANAGE_TEAM',
  ManageUsers = 'MANAGE_USERS',
  RestaurantOwner = 'RESTAURANT_OWNER'
}

export type UserCompanyRole = {
  __typename?: 'UserCompanyRole';
  company: Company;
  id: Scalars['ID']['output'];
  permission: Array<UserCompanyPermission>;
  user: User;
};

export type UserCompanyRoleCreate = {
  colorCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  permission: Array<UserCompanyPermission>;
  username: Scalars['String']['input'];
};

export type UserCompanyRoleUpdate = {
  colorCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  permission: Array<UserCompanyPermission>;
  status: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UserContactInfoInput = {
  addressCountry: Scalars['String']['input'];
  addressLocality: Scalars['String']['input'];
  addressRegion: Scalars['String']['input'];
  deliveryMode: OnlineOrderDeliveryMode;
  email: Scalars['String']['input'];
  expectedTime?: InputMaybe<Scalars['String']['input']>;
  guestName: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  nextUserState?: InputMaybe<OnlineOrderUserState>;
  /**
   * Payment method
   * If not provided, the cash payment method will be used
   */
  paymentMethod?: InputMaybe<OnlineOrderPaymentMethod>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
};

export type UserFilter = {
  status: Scalars['Boolean']['input'];
};

export type UserNotification = {
  __typename?: 'UserNotification';
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  data?: Maybe<UserNotificationState>;
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserNotificationInput = {
  companyId?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<UserNotificationStateInput>;
  link?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationState = {
  __typename?: 'UserNotificationState';
  color?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<NotificationEntityType>;
  nailsAppointment?: Maybe<NailsAppointmentData>;
  name?: Maybe<Scalars['String']['output']>;
  onlineOrder?: Maybe<OnlineOrderData>;
  price?: Maybe<Scalars['String']['output']>;
  pushedNotification?: Maybe<Scalars['Boolean']['output']>;
  tableReservation?: Maybe<TableReservationData>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationStateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  pushedNotification?: InputMaybe<Scalars['Boolean']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum UserRole {
  Admin = 'ADMIN',
  ContractManager = 'CONTRACT_MANAGER',
  Owner = 'OWNER',
  SuperAdmin = 'SUPER_ADMIN'
}

export type UserSnapshot = {
  __typename?: 'UserSnapshot';
  colorCode: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export enum WebMenuPreviewType {
  File = 'FILE',
  System = 'SYSTEM'
}

export type CheckPrintRuleAssignmentQueryVariables = Exact<{
  menuPrintRuleId: Scalars['ID']['input'];
}>;


export type CheckPrintRuleAssignmentQuery = { __typename?: 'Query', checkPrintRuleAssignment?: { __typename?: 'MenuPrintRuleAssignment', id: string } | null };

export type CreatePageRuleMutationVariables = Exact<{
  input: CreatePageRuleInput;
}>;


export type CreatePageRuleMutation = { __typename?: 'Mutation', createPageRule: { __typename?: 'MenuPrintPageRule', id: string } };

export type DeletePageRuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePageRuleMutation = { __typename?: 'Mutation', softDeletePageRule: { __typename?: 'MenuPrintPageRule', id: string } };

export type DeletePrintRuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeletePrintRuleMutation = { __typename?: 'Mutation', softDeletePrintRule: { __typename?: 'MenuPrintRule', id: string, name: string, menuId: string } };

export type UpdatePrintRuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePrintRuleInput;
}>;


export type UpdatePrintRuleMutation = { __typename?: 'Mutation', updatePrintRule: { __typename?: 'MenuPrintRule', id: string, name: string, menuId: string } };

export type PageRuleDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  menuId: Scalars['ID']['input'];
}>;


export type PageRuleDataQuery = { __typename?: 'Query', menu: { __typename?: 'Menu', id: string, companyId: string, title: string, allergics: string, preferredProductPriceMode: MenuProductPriceMode, sections: Array<(
      { __typename?: 'MenuSection' }
      & { ' $fragmentRefs'?: { 'MenuSectionItemFragment': MenuSectionItemFragment } }
    )>, menuProducts: Array<(
      { __typename?: 'MenuProduct' }
      & { ' $fragmentRefs'?: { 'MenuProductItemFragment': MenuProductItemFragment } }
    )> }, printRule: { __typename?: 'MenuPrintRule', id: string, name: string, printerDeviceId?: string | null, pages: Array<{ __typename?: 'MenuPrintPageRule', id: string, name: string, printerDeviceId?: string | null, allowedSections: Array<{ __typename?: 'MenuPrintPageSections', pageRuleId: string, menuSectionId: string, menuSection: { __typename?: 'MenuSection', code: string, id: string, name: string } }> }> } };

export type PrintRuleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PrintRuleQuery = { __typename?: 'Query', printRule: { __typename?: 'MenuPrintRule', id: string, name: string, printerDeviceId?: string | null, menu: { __typename?: 'Menu', sections: Array<{ __typename?: 'MenuSection', id: string, name: string, code: string }> }, pages: Array<{ __typename?: 'MenuPrintPageRule', id: string, name: string, printerDeviceId?: string | null, allowedSections: Array<{ __typename?: 'MenuPrintPageSections', pageRuleId: string, menuSectionId: string, menuSection: { __typename?: 'MenuSection', code: string, id: string, name: string } }> }> } };

export type MenuSectionsQueryVariables = Exact<{
  menuId: Scalars['ID']['input'];
}>;


export type MenuSectionsQuery = { __typename?: 'Query', menuSections: Array<{ __typename?: 'MenuSection', id: string, code: string, name: string }> };

export type PageRuleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PageRuleQuery = { __typename?: 'Query', pageRule: { __typename?: 'MenuPrintPageRule', id: string, name: string, printerDeviceId?: string | null, allowedSections: Array<{ __typename?: 'MenuPrintPageSections', menuSectionId: string, menuSection: { __typename?: 'MenuSection', id: string, code: string, name: string } }> } };

export type PrinterDevicesQueryVariables = Exact<{
  branchID: Scalars['ID']['input'];
}>;


export type PrinterDevicesQuery = { __typename?: 'Query', printerDevices: Array<{ __typename?: 'PrinterDevice', id: string, name: string }> };

export type UpdatePageRuleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdatePageRuleInput;
}>;


export type UpdatePageRuleMutation = { __typename?: 'Mutation', updatePageRule: { __typename?: 'MenuPrintPageRule', id: string } };

export type MenuListQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  menuSource: MenuSource;
}>;


export type MenuListQuery = { __typename?: 'Query', menus: Array<{ __typename?: 'Menu', id: string, title: string }> };

export type GetUniquePrintRuleMutationVariables = Exact<{
  menuId: Scalars['ID']['input'];
  branchId: Scalars['ID']['input'];
}>;


export type GetUniquePrintRuleMutation = { __typename?: 'Mutation', getUniquePrintRule: { __typename?: 'MenuPrintRule', id: string } };

export type CreatePrintRuleMutationVariables = Exact<{
  input: CreatePrintRuleInput;
}>;


export type CreatePrintRuleMutation = { __typename?: 'Mutation', createPrintRule: { __typename?: 'MenuPrintRule', id: string, name: string, menuId: string } };

export type GetPrintRuleAssignmentQueryVariables = Exact<{
  menuId: Scalars['ID']['input'];
  service: MenuPrintRuleService;
}>;


export type GetPrintRuleAssignmentQuery = { __typename?: 'Query', getPrintRuleAssignment?: { __typename?: 'MenuPrintRuleAssignment', id: string, menuId: string, menuPrintRuleId: string } | null };

export type PrintRuleListQueryVariables = Exact<{
  menuId: Scalars['String']['input'];
}>;


export type PrintRuleListQuery = { __typename?: 'Query', getPrintRuleList: { __typename?: 'Menu', id: string, title: string, menuPrintRules: Array<{ __typename?: 'MenuPrintRule', id: string, name: string }> } };

export type SetPrintRuleAssignmentMutationVariables = Exact<{
  input: SetPrintRuleAssignmentInput;
}>;


export type SetPrintRuleAssignmentMutation = { __typename?: 'Mutation', setPrintRuleAssignment?: { __typename?: 'MenuPrintRuleAssignment', id: string, menuId: string, menuPrintRuleId: string } | null };

export type PickedNailAppointmentTeamItemFragment = { __typename?: 'PickedNailAppointmentTeam', id: string, teamName: string, appointmentId: string, teamId: string, team: { __typename?: 'Team', teamMember: Array<{ __typename?: 'TeamMember', userId: string, user: { __typename?: 'User', id: string, username: string, lastName: string, firstName: string } }> } } & { ' $fragmentName'?: 'PickedNailAppointmentTeamItemFragment' };

export type PickedNailAppointmentEmployeeItemFragment = { __typename?: 'PickedNailAppointmentEmployee', id: string, appointmentId: string, userId: string, user: { __typename?: 'UserSnapshot', id: string, username: string, firstName: string, lastName: string, userId?: string | null, colorCode: string } } & { ' $fragmentName'?: 'PickedNailAppointmentEmployeeItemFragment' };

export type BranchItemFragment = { __typename?: 'Branch', id: string, name: string, website?: string | null, streetAddress: string, addressLocality: string, addressRegion: string, postalCode: string, addressCountry: string, priceListLink?: string | null, contactPhone?: string | null } & { ' $fragmentName'?: 'BranchItemFragment' };

export type MenuItemFragment = { __typename?: 'Menu', id: string, title: string, menuProducts: Array<(
    { __typename?: 'MenuProduct' }
    & { ' $fragmentRefs'?: { 'MenuProductItemFragment': MenuProductItemFragment } }
  )> } & { ' $fragmentName'?: 'MenuItemFragment' };

export type MenuProductConfigurationItemFragment = { __typename?: 'MenuProductConfiguration', id: string, title: string, type: ProductConfigurationType, values: Array<(
    { __typename?: 'MenuProductConfigurationValue' }
    & { ' $fragmentRefs'?: { 'MenuProductConfigurationValueItemFragment': MenuProductConfigurationValueItemFragment } }
  )> } & { ' $fragmentName'?: 'MenuProductConfigurationItemFragment' };

export type MenuProductConfigurationValueItemFragment = { __typename?: 'MenuProductConfigurationValue', id: string, name: string, price: number } & { ' $fragmentName'?: 'MenuProductConfigurationValueItemFragment' };

export type MenuProductItemFragment = { __typename?: 'MenuProduct', id: string, code: string, title: string, description: string, images: Array<string>, ingredients: Array<string>, labels?: Array<MenuProductLabel> | null, priceMode: MenuProductPriceMode, discountable: boolean, allergics: string, enabled: boolean, inStock: boolean, menuId: string, sectionId?: string | null, section?: (
    { __typename?: 'MenuSection' }
    & { ' $fragmentRefs'?: { 'MenuSectionItemFragment': MenuSectionItemFragment } }
  ) | null, configurations: Array<{ __typename?: 'MenuProductConfiguration', id: string, title: string, type: ProductConfigurationType, values: Array<(
      { __typename?: 'MenuProductConfigurationValue' }
      & { ' $fragmentRefs'?: { 'MenuProductConfigurationValueItemFragment': MenuProductConfigurationValueItemFragment } }
    )> }> } & { ' $fragmentName'?: 'MenuProductItemFragment' };

export type MenuSectionItemFragment = { __typename?: 'MenuSection', id: string, name: string, description: string, discountable: boolean, code: string, inStock: boolean, enabled: boolean, timeRule: { __typename: 'MenuSectionAlwaysTimeRule', type: MenuSectionTimeRuleType } | { __typename: 'MenuSectionRangeTimeRule', type: MenuSectionTimeRuleType, start: string, end: string, daysOfWeek?: Array<DaysOfWeek> | null, isAllDays?: boolean | null }, menuProducts?: Array<{ __typename?: 'MenuProduct', discountable: boolean }> | null } & { ' $fragmentName'?: 'MenuSectionItemFragment' };

export type ServiceItemFragment = { __typename?: 'NailAppointmentMenuProduct', id: string, title: string, code: string, description: string, images: Array<string>, enabled: boolean, inStock?: boolean | null, ingredients: Array<string>, labels?: Array<MenuProductLabel> | null, allergics: string, priceMode: MenuProductPriceMode, menuId: string, sectionId?: string | null, section?: (
    { __typename?: 'MenuSection' }
    & { ' $fragmentRefs'?: { 'MenuSectionItemFragment': MenuSectionItemFragment } }
  ) | null, configurations: Array<(
    { __typename?: 'MenuProductConfiguration' }
    & { ' $fragmentRefs'?: { 'MenuProductConfigurationItemFragment': MenuProductConfigurationItemFragment } }
  )>, appointmentMenuProductData: { __typename?: 'NailAppointmentProductData', duration: number } } & { ' $fragmentName'?: 'ServiceItemFragment' };

export type TableItemFragment = { __typename?: 'Table', id: string, name: string, seats: number, tableGroupId: string } & { ' $fragmentName'?: 'TableItemFragment' };

export type TableGroupItemFragment = { __typename?: 'TableGroup', id: string, name: string, arrangementCode?: string | null } & { ' $fragmentName'?: 'TableGroupItemFragment' };

export type TeamItemFragment = { __typename?: 'Team', id: string, name: string, description: string, teamMember: Array<{ __typename?: 'TeamMember', id: string, userId: string, user: { __typename?: 'User', username: string, firstName: string, lastName: string } }> } & { ' $fragmentName'?: 'TeamItemFragment' };

export const PickedNailAppointmentTeamItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickedNailAppointmentTeamItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PickedNailAppointmentTeam"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"teamName"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentId"}},{"kind":"Field","name":{"kind":"Name","value":"teamId"}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PickedNailAppointmentTeamItemFragment, unknown>;
export const PickedNailAppointmentEmployeeItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PickedNailAppointmentEmployeeItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PickedNailAppointmentEmployee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"colorCode"}}]}}]}}]} as unknown as DocumentNode<PickedNailAppointmentEmployeeItemFragment, unknown>;
export const BranchItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BranchItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Branch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"streetAddress"}},{"kind":"Field","name":{"kind":"Name","value":"addressLocality"}},{"kind":"Field","name":{"kind":"Name","value":"addressRegion"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"addressCountry"}},{"kind":"Field","name":{"kind":"Name","value":"priceListLink"}},{"kind":"Field","name":{"kind":"Name","value":"contactPhone"}}]}}]} as unknown as DocumentNode<BranchItemFragment, unknown>;
export const MenuSectionItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuSectionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discountable"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"timeRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionAlwaysTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionRangeTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"isAllDays"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountable"}}]}}]}}]} as unknown as DocumentNode<MenuSectionItemFragment, unknown>;
export const MenuProductConfigurationValueItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProductConfigurationValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]} as unknown as DocumentNode<MenuProductConfigurationValueItemFragment, unknown>;
export const MenuProductItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"ingredients"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"priceMode"}},{"kind":"Field","name":{"kind":"Name","value":"discountable"}},{"kind":"Field","name":{"kind":"Name","value":"allergics"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuSectionItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuSectionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discountable"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"timeRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionAlwaysTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionRangeTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"isAllDays"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountable"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProductConfigurationValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]} as unknown as DocumentNode<MenuProductItemFragment, unknown>;
export const MenuItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Menu"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"menuProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuProductItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuSectionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discountable"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"timeRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionAlwaysTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionRangeTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"isAllDays"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountable"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProductConfigurationValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"ingredients"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"priceMode"}},{"kind":"Field","name":{"kind":"Name","value":"discountable"}},{"kind":"Field","name":{"kind":"Name","value":"allergics"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuSectionItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}}]}}]} as unknown as DocumentNode<MenuItemFragment, unknown>;
export const MenuProductConfigurationItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductConfigurationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProductConfiguration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProductConfigurationValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]} as unknown as DocumentNode<MenuProductConfigurationItemFragment, unknown>;
export const ServiceItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NailAppointmentMenuProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"ingredients"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"allergics"}},{"kind":"Field","name":{"kind":"Name","value":"priceMode"}},{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuSectionItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuProductConfigurationItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointmentMenuProductData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProductConfigurationValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuSectionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discountable"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"timeRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionAlwaysTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionRangeTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"isAllDays"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountable"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductConfigurationItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProductConfiguration"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"}}]}}]}}]} as unknown as DocumentNode<ServiceItemFragment, unknown>;
export const TableItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TableItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Table"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"seats"}},{"kind":"Field","name":{"kind":"Name","value":"tableGroupId"}}]}}]} as unknown as DocumentNode<TableItemFragment, unknown>;
export const TableGroupItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TableGroupItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TableGroup"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"arrangementCode"}}]}}]} as unknown as DocumentNode<TableGroupItemFragment, unknown>;
export const TeamItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeamItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Team"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"teamMember"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<TeamItemFragment, unknown>;
export const CheckPrintRuleAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"checkPrintRuleAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menuPrintRuleId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPrintRuleAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"menuPrintRuleId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menuPrintRuleId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CheckPrintRuleAssignmentQuery, CheckPrintRuleAssignmentQueryVariables>;
export const CreatePageRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePageRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePageRuleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPageRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePageRuleMutation, CreatePageRuleMutationVariables>;
export const DeletePageRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePageRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"softDeletePageRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePageRuleMutation, DeletePageRuleMutationVariables>;
export const DeletePrintRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deletePrintRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"softDeletePrintRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}}]}}]}}]} as unknown as DocumentNode<DeletePrintRuleMutation, DeletePrintRuleMutationVariables>;
export const UpdatePrintRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePrintRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePrintRuleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePrintRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}}]}}]}}]} as unknown as DocumentNode<UpdatePrintRuleMutation, UpdatePrintRuleMutationVariables>;
export const PageRuleDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageRuleData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menu"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"companyId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"allergics"}},{"kind":"Field","name":{"kind":"Name","value":"preferredProductPriceMode"}},{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuSectionItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuProductItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"printRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"printerDeviceId"}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"printerDeviceId"}},{"kind":"Field","name":{"kind":"Name","value":"allowedSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageRuleId"}},{"kind":"Field","name":{"kind":"Name","value":"menuSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"menuSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuSectionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discountable"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"timeRule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionAlwaysTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSectionRangeTimeRule"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"daysOfWeek"}},{"kind":"Field","name":{"kind":"Name","value":"isAllDays"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"discountable"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProductConfigurationValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MenuProductItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MenuProduct"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"ingredients"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"priceMode"}},{"kind":"Field","name":{"kind":"Name","value":"discountable"}},{"kind":"Field","name":{"kind":"Name","value":"allergics"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"inStock"}},{"kind":"Field","name":{"kind":"Name","value":"section"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuSectionItem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"configurations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"values"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MenuProductConfigurationValueItem"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}},{"kind":"Field","name":{"kind":"Name","value":"sectionId"}}]}}]} as unknown as DocumentNode<PageRuleDataQuery, PageRuleDataQueryVariables>;
export const PrintRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrintRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"printerDeviceId"}},{"kind":"Field","name":{"kind":"Name","value":"menu"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"printerDeviceId"}},{"kind":"Field","name":{"kind":"Name","value":"allowedSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageRuleId"}},{"kind":"Field","name":{"kind":"Name","value":"menuSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"menuSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PrintRuleQuery, PrintRuleQueryVariables>;
export const MenuSectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MenuSections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menuSections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"menuId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<MenuSectionsQuery, MenuSectionsQueryVariables>;
export const PageRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PageRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"printerDeviceId"}},{"kind":"Field","name":{"kind":"Name","value":"allowedSections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menuSectionId"}},{"kind":"Field","name":{"kind":"Name","value":"menuSection"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PageRuleQuery, PageRuleQueryVariables>;
export const PrinterDevicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrinterDevices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"branchID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"printerDevices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"branchID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"branchID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<PrinterDevicesQuery, PrinterDevicesQueryVariables>;
export const UpdatePageRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePageRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePageRuleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePageRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePageRuleMutation, UpdatePageRuleMutationVariables>;
export const MenuListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MenuList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menuSource"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MenuSource"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"menus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"menuSource"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menuSource"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<MenuListQuery, MenuListQueryVariables>;
export const GetUniquePrintRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"getUniquePrintRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"branchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUniquePrintRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"menuId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}}},{"kind":"Argument","name":{"kind":"Name","value":"branchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"branchId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetUniquePrintRuleMutation, GetUniquePrintRuleMutationVariables>;
export const CreatePrintRuleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePrintRule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePrintRuleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPrintRule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}}]}}]}}]} as unknown as DocumentNode<CreatePrintRuleMutation, CreatePrintRuleMutationVariables>;
export const GetPrintRuleAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPrintRuleAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"service"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MenuPrintRuleService"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPrintRuleAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"menuId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}}},{"kind":"Argument","name":{"kind":"Name","value":"service"},"value":{"kind":"Variable","name":{"kind":"Name","value":"service"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}},{"kind":"Field","name":{"kind":"Name","value":"menuPrintRuleId"}}]}}]}}]} as unknown as DocumentNode<GetPrintRuleAssignmentQuery, GetPrintRuleAssignmentQueryVariables>;
export const PrintRuleListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrintRuleList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPrintRuleList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"menuId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"menuId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"menuPrintRules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PrintRuleListQuery, PrintRuleListQueryVariables>;
export const SetPrintRuleAssignmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetPrintRuleAssignment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetPrintRuleAssignmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setPrintRuleAssignment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"menuId"}},{"kind":"Field","name":{"kind":"Name","value":"menuPrintRuleId"}}]}}]}}]} as unknown as DocumentNode<SetPrintRuleAssignmentMutation, SetPrintRuleAssignmentMutationVariables>;